const { createVeriffFrame } = require("@veriff/incontext-sdk");

(function () {
  class Loan extends Common {
    constructor() {
      super();
    }

    toggleNationalityCountry() {
      const operation = this;
      const isPanama = !!$("#migration_card_fields").length || !!$("#panama-nationality-validation-alert").length;

      function isCitizenIdType(selected) {
        return selected === "national" || selected === "naturalized";
      }

      function toggle() {
        var selected = $(operation.ui.loanCustomerNationality).val();
        const selectedCountry = $(
          operation.ui.loanCustomerNationalityCountry,
        ).val();
        const requiresCountry = selected && !isCitizenIdType(selected);
        // In Panama, nationality country sits below the ID field, so do not block typing the ID.
        const canTypeDocument = isPanama
          ? !!selected
          : !requiresCountry || !!selectedCountry;

        if (requiresCountry) {
          $("#nationality_country_field").removeClass("d-none");
          $(operation.ui.loanCustomerNationalityCountry).prop("required", true);

          if (selected === "foreigner" && !isPanama) {
            var dialog = bootbox.dialog({
              message:
                '<p class="text-center"><i class="fas fa-exclamation-triangle fa-4x text-warning"></i></p><h5 class="text-center">Clientes extranjeros que tienen su estatus migratorio en el siguiente proceso, NO aplican para préstamos:</h5><ul class="text-left"><li>Estatus migratorio en Trámite</li><li>Estatus migratorio de Permiso temporal</li><li>Estatus migratorio de Permiso de trabajo</li></ul>',
              buttons: {
                ok: {
                  label: "Entendido",
                  className: "btn-primary",
                },
              },
            });
            dialog.init(function () {
              $(".bootbox .modal-footer").addClass("justify-content-center");
            });
          }
        } else {
          $("#nationality_country_field").addClass("d-none");
          $(operation.ui.loanCustomerNationalityCountry).prop(
            "required",
            false,
          );
          $(operation.ui.loanCustomerNationalityCountry).val("");
        }

        $(operation.ui.customerIdNumber).prop("disabled", !canTypeDocument);
        $(operation.ui.customerIdNumberConfirmation).prop(
          "disabled",
          !canTypeDocument,
        );

        if (!canTypeDocument) {
          $(operation.ui.customerIdNumber).val("");
          $(operation.ui.customerIdNumberConfirmation).val("");
        }

        // Show/hide NIT fields for Cédula E (Panama only)
        if ($("#migration_card_fields").length) {
          if (selected === "foreigner") {
            $("#migration_card_fields").removeClass("d-none");
            $("#loan_customer_attributes_nit").prop("required", true);
            $("#loan_customer_attributes_nit").prop("disabled", false).prop("readonly", false);
            $("#loan_customer_attributes_nit_confirmation").prop(
              "required",
              true,
            );
            $("#loan_customer_attributes_nit_confirmation").prop(
              "disabled",
              false,
            );
            $("#loan_step_two_nit_field").addClass("d-none");
            $("#loan_step_two_nit_field input").prop("disabled", true);
          } else {
            $("#migration_card_fields").addClass("d-none");
            $("#loan_customer_attributes_nit").prop("required", false);
            $("#loan_customer_attributes_nit").prop("disabled", true);
            $("#loan_customer_attributes_nit").val("");
            $("#loan_customer_attributes_nit_confirmation").prop(
              "required",
              false,
            );
            $("#loan_customer_attributes_nit_confirmation").prop(
              "disabled",
              true,
            );
            $("#loan_customer_attributes_nit_confirmation").val("");
            $("#loan_step_two_nit_field").removeClass("d-none");
            // Panameño / naturalizado: NIT = cédula, no editable
            const idNumber = $(operation.ui.customerIdNumber).val();
            const $stepTwoNit = $("#loan_step_two_nit_field input, #loan_customer_attributes_nit_step_two");
            $stepTwoNit
              .prop("disabled", false)
              .prop("readonly", true)
              .addClass("bg-light");
            if (idNumber) $stepTwoNit.val(idNumber);
          }
        }

        operation.syncPanamaBirthCountryOptions();
        operation.syncPanamaNationalNitFromId();
      }

      $(operation.ui.loanCustomerNationality).on("change", toggle);
      $(operation.ui.loanCustomerNationalityCountry).on("change", toggle);
      let lastBirthCountryDocType = null;
      $(operation.ui.customerIdNumber).on("input change blur", function () {
        operation.syncPanamaNationalNitFromId();
        const docType = (
          ($(operation.ui.customerIdNumber).val() || "").toUpperCase().split("-")[0] || ""
        );
        const birthDocType = docType === "PE" ? "PE" : "OTHER";
        if (birthDocType !== lastBirthCountryDocType) {
          lastBirthCountryDocType = birthDocType;
          operation.syncPanamaBirthCountryOptions(true);
        }
      });
      toggle();
    }

    syncPanamaNationalNitFromId() {
      const isPanama =
        !!$("#migration_card_fields").length ||
        !!$("#panama-nationality-validation-alert").length;
      if (!isPanama) return;

      const nationality = $(this.ui.loanCustomerNationality).val();
      if (nationality !== "national" && nationality !== "naturalized") return;

      const idNumber = $(this.ui.customerIdNumber).val();
      const $stepTwoNit = $(
        "#loan_step_two_nit_field input, #loan_customer_attributes_nit_step_two",
      );
      if (!$stepTwoNit.length) return;

      $stepTwoNit.prop("readonly", true).addClass("bg-light");
      if (idNumber) $stepTwoNit.val(idNumber);
    }

    toggleSecondNationalityField() {
      const operation = this;

      function toggle() {
        const hasSecondNationality =
          $(operation.ui.customerHasSecondNationality).val() === "true";

        if (hasSecondNationality) {
          $("#second_nationality_country_field").removeClass("d-none");
          $(operation.ui.customerSecondNationalityCountry).prop(
            "required",
            true,
          );
        } else {
          $("#second_nationality_country_field").addClass("d-none");
          $(operation.ui.customerSecondNationalityCountry).prop(
            "required",
            false,
          );
          $(operation.ui.customerSecondNationalityCountry).val("");
        }
      }

      $(operation.ui.customerHasSecondNationality).on("change", toggle);
      toggle();
    }

    validatePanamaNationalityCriteria() {
      if (!["es_pan", "es_pan_lsg"].includes(document.documentElement.lang)) {
        return true;
      }

      const normalize = function (value) {
        return (value || "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim();
      };
      const allowedCountries = [
        "panama",
        "colombia",
        "nicaragua",
        "republica dominicana",
        "dominican republic",
        "el salvador",
      ];
      const peAllowedCountries = [
        "colombia",
        "nicaragua",
        "republica dominicana",
        "dominican republic",
        "el salvador",
      ];
      const nationality = $(this.ui.loanCustomerNationality).val();
      const nationalityCountry = normalize(
        $(this.ui.loanCustomerNationalityCountry).val(),
      );
      const birthCountry = normalize($(this.ui.customerBirthCountry).val());
      const hasSecondNationality =
        $(this.ui.customerHasSecondNationality).val() === "true";
      const secondNationalityCountry = normalize(
        $(this.ui.customerSecondNationalityCountry).val(),
      );
      const documentNumber = (
        $(this.ui.customerIdNumber).val() || ""
      ).toUpperCase();
      const documentType = documentNumber.split("-")[0];

      const primaryValid =
        nationality === "national" ||
        nationality === "naturalized" ||
        allowedCountries.includes(nationalityCountry);
      const secondValid =
        !hasSecondNationality ||
        allowedCountries.includes(secondNationalityCountry);

      if (!primaryValid || !secondValid) {
        return false;
      }

      if (documentType === "E") {
        return allowedCountries.includes(birthCountry);
      }

      if (documentType === "PE") {
        return peAllowedCountries.includes(birthCountry);
      }

      return true;
    }

    // Dedupe options already rendered by the server (UI only — does not touch DB).
    // selectpicker can leave the first real option duplicated when JS rebuilds the list.
    dedupeSelectOptions($select) {
      if (!$select || !$select.length) return;

      const seen = {};
      $select.find("option").each(function () {
        const value = $(this).attr("value");
        if (value === undefined || value === null || value === "") return;

        const key = String(value)
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .replace(/\s+/g, " ")
          .trim();

        if (seen[key]) {
          $(this).remove();
        } else {
          seen[key] = true;
        }
      });
    }

    refreshBirthCountryWidget($birthCountry) {
      if ($birthCountry.data("selectpicker") && $.fn.selectpicker) {
        $birthCountry.selectpicker("refresh");
      } else if ($birthCountry.hasClass("select2-hidden-accessible") && $.fn.select2) {
        $birthCountry.trigger("change.select2");
      }
    }

    panamaBirthCountryOptionLists() {
      const $json = $("#panama-birth-country-options");
      if (!$json.length) {
        return { allowed: [], pe_allowed: [] };
      }
      try {
        return JSON.parse($json.text() || "{}");
      } catch (e) {
        return { allowed: [], pe_allowed: [] };
      }
    }

    syncPanamaBirthCountryOptions(forceRebuild) {
      if (!["es_pan", "es_pan_lsg"].includes(document.documentElement.lang)) {
        return;
      }

      const $birthCountry = $(this.ui.customerBirthCountry);
      if (!$birthCountry.length) {
        return;
      }

      const documentNumber = (
        $(this.ui.customerIdNumber).val() || ""
      ).toUpperCase();
      const documentType = documentNumber.split("-")[0];
      const needsPeList = documentType === "PE";
      const lists = this.panamaBirthCountryOptionLists();
      const options = needsPeList
        ? lists.pe_allowed || []
        : lists.allowed || [];

      // On normal page load the server already rendered a unique list.
      // Only rebuild when PE list is required (or caller forces it).
      if (!forceRebuild && !needsPeList) {
        this.dedupeSelectOptions($birthCountry);
        this.refreshBirthCountryWidget($birthCountry);
        return;
      }

      const currentValue = $birthCountry.val();
      const promptText =
        $birthCountry.find('option[value=""]').text() || "Seleccione";
      const wasSelectpicker = !!$birthCountry.data("selectpicker");
      const wasSelect2 = $birthCountry.hasClass("select2-hidden-accessible");

      if (wasSelectpicker) {
        $birthCountry.selectpicker("destroy");
      }
      if (wasSelect2) {
        $birthCountry.select2("destroy");
      }

      $birthCountry.empty();
      $birthCountry.append(new Option(promptText, "", false, false));

      const seen = {};
      (options || []).forEach(function (option) {
        const value = Array.isArray(option) ? option[1] : option;
        const text = Array.isArray(option) ? option[0] : option;
        if (value === undefined || value === null || value === "") return;
        const key = String(value)
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .replace(/\s+/g, " ")
          .trim();
        if (seen[key]) return;
        seen[key] = true;
        $birthCountry.append(new Option(text, value));
      });

      const valueStillValid = (options || []).some(function (option) {
        const value = Array.isArray(option) ? option[1] : option;
        return value === currentValue;
      });
      $birthCountry.val(valueStillValid ? currentValue : "");

      if (wasSelectpicker && $.fn.selectpicker) {
        $birthCountry.selectpicker();
      }
      if (wasSelect2 && $.fn.select2) {
        $birthCountry.select2({
          width: "100%",
          minimumResultsForSearch: 5,
        });
      }
    }

    togglePanamaNationalityAlert(show) {
      if (!$("#panama-nationality-validation-alert").length) {
        return;
      }

      if (show) {
        $("#panama-nationality-validation-alert").removeClass("d-none");
      } else {
        $("#panama-nationality-validation-alert").addClass("d-none");
      }
    }

    togglePepFields() {
      const operation = this;

      function isYesValue(val) {
        return val === "true" || val === true || val === "1" || val === 1;
      }

      function pepInputs($container) {
        return $container
          .find("input, select, textarea")
          .not(".js-family-pep-link-type");
      }

      function syncFamilyPepLinkTypeSelect($link) {
        if ($link.hasClass("select2-hidden-accessible")) {
          $link.trigger("change.select2");
        }
      }

      function restoreFamilyPepLinkType() {
        const $link = $(".js-family-pep-link-type");
        if (!$link.length) return;

        if (!$link.val()) {
          const kinshipVal = String($(".js-family-pep-kinship").val() || "");
          const otherVal = String(
            $(
              "#loan_customer_detail_attributes_family_pep_relationship_other",
            ).val() || "",
          );
          if (kinshipVal && kinshipVal !== "close_associate") {
            $link.val("close_relative");
          } else if (kinshipVal === "close_associate" || otherVal) {
            $link.val("close_associate");
          }
        }

        syncFamilyPepLinkTypeSelect($link);
      }

      function togglePep(fromUserChange) {
        var isPep = isYesValue($(operation.ui.customerIsPep).val());
        var $container = $(operation.ui.customerPepContainer);
        if (isPep) {
          $container.removeClass("d-none");
          pepInputs($container).prop("disabled", false);
        } else {
          $container.addClass("d-none");
          if (fromUserChange) {
            $("#loan_customer_detail_attributes_pep_from_at").val("");
            $("#loan_customer_detail_attributes_pep_to_at").val("");
            $("#loan_customer_detail_attributes_pep_position").val("");
            $(
              "input[name='loan[customer_detail_attributes][pep_functions][]']",
            ).prop("checked", false);
            $("#loan_customer_detail_attributes_pep_function_other").val("");
            $(operation.ui.customerPepFunctionsOtherContainer).addClass("d-none");
          }
          pepInputs($container).prop("disabled", true);
        }
      }

      function togglePepOther() {
        var checked = $(
          "input[name='loan[customer_detail_attributes][pep_functions][]'][value='other']",
        ).is(":checked");
        if (checked) {
          $(operation.ui.customerPepFunctionsOtherContainer).removeClass(
            "d-none",
          );
        } else {
          $(operation.ui.customerPepFunctionsOtherContainer).addClass("d-none");
          $("#loan_customer_detail_attributes_pep_function_other").val("");
        }
      }

      function toggleFamilyPep(fromUserChange) {
        var familyIsPep = isYesValue($(operation.ui.customerFamilyIsPep).val());
        var $container = $(operation.ui.customerFamilyPepContainer);
        if (familyIsPep) {
          $container.removeClass("d-none");
          pepInputs($container).prop("disabled", false);
          $(".js-family-pep-link-type").prop("required", true).prop("disabled", false);
          restoreFamilyPepLinkType();
        } else {
          $container.addClass("d-none");
          $(".js-family-pep-link-type").prop("required", false);
          if (fromUserChange) {
            $(".js-family-pep-link-type").val("").trigger("change");
            $(operation.ui.customerFamilyPepRelationship).val("");
            $(
              "#loan_customer_detail_attributes_family_pep_relationship_other",
            ).val("");
            $("#loan_customer_detail_attributes_family_pep_first_name").val("");
            $("#loan_customer_detail_attributes_family_pep_second_name").val("");
            $("#loan_customer_detail_attributes_family_pep_first_last_name").val(
              "",
            );
            $("#loan_customer_detail_attributes_family_pep_second_last_name").val(
              "",
            );
            $("#loan_customer_detail_attributes_family_pep_name").val("");
            $("#loan_customer_detail_attributes_family_pep_position").val("");
            $(operation.ui.customerFamilyPepRelationshipOtherContainer).addClass(
              "d-none",
            );
          }
          pepInputs($container).prop("disabled", true);
        }
        toggleFamilyPepLinkType();
      }

      function toggleFamilyPepLinkType(fromUserChange) {
        const linkType = $(".js-family-pep-link-type").val();
        const kinship = $("#family_pep_kinship_fields");
        const associate = $("#family_pep_associate_fields");
        const kinshipSelect = $(".js-family-pep-kinship");
        const associateHidden = $(".js-family-pep-associate-value");
        const relationOther = $(
          "#loan_customer_detail_attributes_family_pep_relationship_other",
        );

        kinship.addClass("d-none");
        associate.addClass("d-none");
        kinshipSelect.prop("disabled", true).prop("required", false);
        associateHidden.prop("disabled", true);
        relationOther.prop("required", false);

        if (linkType === "close_relative") {
          kinship.removeClass("d-none");
          kinshipSelect.prop("disabled", false).prop("required", true);
          if (fromUserChange) {
            relationOther.val("");
          }
        } else if (linkType === "close_associate") {
          associate.removeClass("d-none");
          associateHidden.prop("disabled", false);
          if (fromUserChange) {
            kinshipSelect.val("");
          }
          relationOther.prop("required", true);
        }
      }

      function toggleFamilyPepOther() {
        // Kept for compatibility; kinship no longer uses "other".
      }

      function toggleFamilyPepFunctionOther() {
        var checked = $(
          "input[name='loan[customer_detail_attributes][family_pep_functions][]'][value='other']",
        ).is(":checked");
        if (checked) {
          $(operation.ui.customerFamilyPepFunctionsOtherContainer).removeClass(
            "d-none",
          );
        } else {
          $(operation.ui.customerFamilyPepFunctionsOtherContainer).addClass(
            "d-none",
          );
          $("#loan_customer_detail_attributes_family_pep_function_other").val(
            "",
          );
        }
      }

      $(operation.ui.customerIsPep).on("change", function () {
        togglePep(true);
      });
      $(document).on(
        "change",
        "input[name='loan[customer_detail_attributes][pep_functions][]']",
        togglePepOther,
      );
      $(operation.ui.customerFamilyIsPep).on("change", function () {
        toggleFamilyPep(true);
      });
      $(".js-family-pep-link-type").on("change", function () {
        toggleFamilyPepLinkType(true);
      });
      $(operation.ui.customerFamilyPepRelationship).on(
        "change",
        toggleFamilyPepOther,
      );
      $(document).on(
        "change",
        "input[name='loan[customer_detail_attributes][family_pep_functions][]']",
        toggleFamilyPepFunctionOther,
      );

      togglePep(false);
      togglePepOther();
      toggleFamilyPep(false);
      toggleFamilyPepFunctionOther();
    }

    toggleEmployeeFields() {
      const operation = this;

      function refreshSelectOptions($select, pairs, keepValue) {
        if (!$select.length) return;
        const current = keepValue ? $select.val() : "";
        $select.empty();
        $select.append(new Option("Seleccione", "", false, false));
        (pairs || []).forEach(function (pair) {
          $select.append(new Option(pair[0], pair[1], false, false));
        });
        if (
          current &&
          pairs.some(function (pair) {
            return String(pair[1]) === String(current);
          })
        ) {
          $select.val(current);
        }
        $select.trigger("change.select2");
      }

      function setEmployerLabel(activity) {
        const $input = $(operation.ui.customerEmployerName);
        if (!$input.length) return;
        const $label = $input
          .closest(".form-group, .col-12, .loan-flow-v2__field")
          .find("label")
          .first();
        if (!$label.length) return;
        let label = $input.data("label-employee") || "Nombre de la empresa";
        if (activity === "independent") {
          label = $input.data("label-independent") || "Nombre de su negocio";
        } else if (activity === "university_student") {
          label = $input.data("label-student") || "Nombre de la empresa";
        }
        $label.text(label);
      }

      function toggleEmployee() {
        var activity = $(operation.ui.customerWorkActivity).val();
        const isEmployee = activity === "employee";
        const isIndependent = activity === "independent";
        const isDependent = activity === "dependent";
        const isStudent = activity === "university_student";

        const showOccupation = !!activity && !isStudent;
        const showMainActivity = !!activity && !isDependent && !isStudent;
        const showEmployer = isEmployee || isIndependent;
        const showJobTitle = isEmployee;
        const showWorkAddress = isEmployee || isIndependent;
        const showIncomeExpenses = !!activity && !isDependent && !isStudent;
        const showStudentFields = isStudent;
        const showDependentFields = isDependent;

        $(".js-occupation-row").toggleClass("d-none", !showOccupation);
        $(".js-main-activity-row").toggleClass("d-none", !showMainActivity);
        $("#student_fields").toggleClass("d-none", !showStudentFields);
        $("#dependent_of_fields").toggleClass("d-none", !showDependentFields);
        $(operation.ui.customerEmployeeContainer).toggleClass(
          "d-none",
          !showEmployer,
        );
        $("#employee_job_title_fields").toggleClass("d-none", !showJobTitle);
        $(".js-work-address-row").toggleClass("d-none", !showWorkAddress);
        $(".js-monthly-income-row").toggleClass("d-none", !showIncomeExpenses);
        $(".js-other-income-row").toggleClass("d-none", !showIncomeExpenses);

        setEmployerLabel(activity);

        $(operation.ui.customerEmployerName).prop("required", showEmployer);
        $(operation.ui.customerJobTitle).prop("required", showJobTitle);
        $(".js-profession-text").prop("required", showOccupation);
        $(".js-profession-occupation").prop("required", showOccupation);
        $(".js-main-activity-text").prop("required", showMainActivity);
        if (!showOccupation) {
          $(".js-profession-text").val("");
          $(".js-profession-occupation").val(null).trigger("change.select2");
        }
        if (!showMainActivity) {
          $(".js-main-activity-text").val("");
        }
        $(
          "#loan_customer_detail_attributes_student_career, #customer_detail_student_career",
        ).prop("required", isStudent);

        operation.setFileInputsRequired($(".js-student-card-photo"), isStudent);
        $("#dependent_of_fields")
          .find(
            "input[name*='dependent_of_first_name'], input[name*='dependent_of_first_last_name'], input[name*='dependent_of_second_last_name'], input[name*='dependent_of_id_number'], input[name*='dependent_of_phone'], input[name*='dependent_of_monthly_income'], input[name*='dependent_of_profession_text'], input[name*='dependent_of_main_activity_text'], input[name*='dependent_of_employer_name'], input[name*='dependent_of_work_address'], input[name*='dependent_of_job_title']",
          )
          .prop("required", isDependent);
        operation.setFileInputsRequired(
          $("#dependent_of_fields").find("input[name*='dependent_of_id_photo']"),
          isDependent,
        );

        if (!isDependent) {
          $("#dependent_of_fields input[type='text'], #dependent_of_fields input[type='number'], #dependent_of_fields input:not([type])").val("");
          $("#dependent_of_fields input[type='file']").val("");
        }
        if (!isStudent) {
          $(
            "#loan_customer_detail_attributes_student_career, #customer_detail_student_career",
          ).val("");
          $("#tutor_fields input").val("");
          $("#tutor_fields select").val(null).trigger("change.select2");
        }
        if (!showEmployer) {
          $(operation.ui.customerEmployerName).val("");
        }
        if (!showJobTitle) {
          $(operation.ui.customerJobTitle).val("");
        }
        const $workAddressText = $(
          "#loan_customer_detail_attributes_work_address_text",
        );
        const hasV2WorkAddressText = $workAddressText.length > 0;

        if (!showWorkAddress) {
          $(
            "#loan_customer_detail_attributes_work_province_id, #loan_customer_detail_attributes_work_district_id, #loan_customer_detail_attributes_work_jurisdiction_id",
          )
            .val(null)
            .trigger("change");
          $(
            "#loan_customer_detail_attributes_work_address_street, #loan_customer_detail_attributes_work_address_house_name, #loan_customer_detail_attributes_work_address_house_number, #loan_customer_detail_attributes_work_address_floor",
          ).val("");
          $workAddressText.val("");
        }

        if (hasV2WorkAddressText) {
          $workAddressText.prop("required", showWorkAddress);
        } else {
          $(
            "#loan_customer_detail_attributes_work_province_id, #loan_customer_detail_attributes_work_district_id, #loan_customer_detail_attributes_work_jurisdiction_id, #loan_customer_detail_attributes_work_address_street, #loan_customer_detail_attributes_work_address_house_name, #loan_customer_detail_attributes_work_address_house_number, #loan_customer_detail_attributes_work_address_floor",
          ).prop("required", showWorkAddress);
        }

        const monthlyIncome = $(
          "#loan_customer_detail_attributes_monthly_income, #customer_detail_monthly_income",
        );
        if (monthlyIncome.length) {
          monthlyIncome.prop("required", showIncomeExpenses);
          if (!showIncomeExpenses) monthlyIncome.val("");
        }
        $(".js-has-other-income").prop("required", showIncomeExpenses);
        if (!showIncomeExpenses) {
          $(".js-has-other-income").val(null).trigger("change.select2");
          $(".js-other-income-details").addClass("d-none");
          $(".js-other-income-details input, .js-other-income-details select").val("");
        }

        operation.toggleOtherIncomeFields();
        operation.toggleFundsOriginFields();
      }

      $(operation.ui.customerWorkActivity).on("change", toggleEmployee);
      $(".js-has-other-income").on("change", function () {
        operation.toggleOtherIncomeFields();
      });
      $(".js-tutor-occupation").on("change", function () {
        operation.toggleTutorRetirementCard();
      });
      $(".js-illicit-activities").on("change", function () {
        operation.toggleIllicitExplanation();
      });
      $(".js-funds-origin-document-type").on("change", function () {
        $(this).attr("data-selected", $(this).val() || "");
        operation.toggleFundsOriginFileFields();
      });
      toggleEmployee();
      operation.toggleIllicitExplanation();
    }

    bindProfessionHelpModal() {
      const moveProfessionModalToBody = function () {
        const $modal = $("#professionHelpModal");
        if ($modal.length && $modal.parent()[0] !== document.body) {
          $modal.appendTo("body");
        }
        return $modal;
      };

      $(document)
        .off("click.professionHelp", ".js-profession-help")
        .on("click.professionHelp", ".js-profession-help", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const $btn = $(this);
          if ($.fn.tooltip) $btn.tooltip("hide");
          const inputSel = $btn.data("professionInput") || $btn.attr("data-profession-input");
          const $modal = moveProfessionModalToBody();
          $modal.data("targetInput", inputSel);
          $modal.modal("show");
        });

      $(document)
        .off("click.professionHelpClose", "#professionHelpModal [data-dismiss='modal']")
        .on("click.professionHelpClose", "#professionHelpModal [data-dismiss='modal']", function (e) {
          e.preventDefault();
          $("#professionHelpModal").modal("hide");
        });

      if ($.fn.tooltip) {
        $(".js-profession-help").tooltip({
          container: "body",
          placement: "top",
          trigger: "hover focus",
        });
      }
    }

    toggleOtherIncomeFields() {
      const raw = $(".js-has-other-income").val();
      const show = raw === "true" || raw === true;
      $(".js-other-income-details").toggleClass("d-none", !show);
      $(".js-other-income-details input, .js-other-income-details select").prop(
        "required",
        show,
      );
      if (!show) {
        $(".js-other-income-details input").val("");
        $(".js-other-income-details select").val(null).trigger("change.select2");
      }
    }

    fileInputHasExisting(input) {
      return (
        $(input).closest("[data-loan-flow-file]").attr("data-existing-file") ===
        "true"
      );
    }

    fileInputFilled(input) {
      if (!input) return false;
      if (input.files && input.files.length > 0) return true;
      return this.fileInputHasExisting(input);
    }

    setFileInputsRequired($inputs, needed) {
      const operation = this;
      $inputs.each(function () {
        $(this).prop(
          "required",
          !!needed && !operation.fileInputHasExisting(this),
        );
      });
    }

    toggleTutorRetirementCard() {
      const isRetired = $(".js-tutor-occupation").val() === "retired";
      $(".js-tutor-retirement-card").toggleClass("d-none", !isRetired);
      this.setFileInputsRequired($(".js-retirement-card-photo"), isRetired);
    }

    toggleIllicitExplanation() {
      const raw = $(".js-illicit-activities").val();
      const show = raw === "true" || raw === true;
      $(".js-illicit-explanation").toggleClass("d-none", !show);
      $(
        "#loan_customer_detail_attributes_illicit_activities_explanation",
      ).prop("required", show);
      if (!show) {
        $(
          "#loan_customer_detail_attributes_illicit_activities_explanation",
        ).val("");
      }
    }

    toggleFundsOriginFields() {
      const activity = $(this.ui.customerWorkActivity).val();
      const section = $("#funds_origin_section");
      const select = $(".js-funds-origin-document-type");
      const tutorFields = $("#tutor_fields");
      if (!section.length || !select.length) return;

      const preferred =
        select.val() || select.attr("data-selected") || "";

      // Student: force Apoyo familiar + tutor fields
      if (activity === "university_student") {
        section.removeClass("d-none");
        select.empty();
        select.append(new Option("Apoyo familiar", "family_support", true, true));
        select
          .attr("data-selected", "family_support")
          .prop("required", true)
          .val("family_support")
          .trigger("change.select2");
        tutorFields.removeClass("d-none");
        tutorFields.find("input, select").prop("required", true);
        this.toggleTutorRetirementCard();
        this.toggleFundsOriginFileFields();
        return;
      }

      tutorFields.addClass("d-none");
      tutorFields.find("input, select").prop("required", false).val("");

      let documentsMap = {};
      try {
        documentsMap = JSON.parse(
          $(this.ui.customerWorkActivity).attr("data-funds-documents") || "{}",
        );
      } catch (e) {
        documentsMap = {};
      }

      const options = (documentsMap[activity] || []).map(function (pair) {
        return [pair[0], pair[1]];
      });
      // Preserve legacy "estado de cuenta" if this loan already saved that choice.
      if (
        preferred === "bank_movements" &&
        !options.some(function (pair) {
          return pair[1] === "bank_movements";
        })
      ) {
        options.push([
          "Estado de cuenta bancaria (últimos dos meses)",
          "bank_movements",
        ]);
      }
      const allowedValues = options.map(function (pair) {
        return pair[1];
      });
      const restore = allowedValues.indexOf(preferred) !== -1 ? preferred : "";

      select.empty();
      select.append(
        new Option("Seleccione el documento a subir", "", false, false),
      );
      options.forEach(function (pair) {
        const selected = pair[1] === restore;
        select.append(new Option(pair[0], pair[1], selected, selected));
      });

      if (options.length) {
        section.removeClass("d-none");
        select.prop("required", true);
        if (restore) select.val(restore);
      } else {
        section.addClass("d-none");
        select.prop("required", false).val("");
      }

      select.attr("data-selected", select.val() || "");
      select.trigger("change.select2");
      this.toggleFundsOriginFileFields();
    }

    toggleFundsOriginFileFields() {
      const selected = $(".js-funds-origin-document-type").val();
      const requiresBankMovements = [
        "student_card",
        "health_card",
        "municipal_permit",
        "operations_notice",
      ];

      $(".js-funds-file").addClass("d-none");
      this.setFileInputsRequired(
        $(".js-funds-file input[type='file']"),
        false,
      );

      if (!selected || selected === "family_support") return;

      const selectedFile = $(
        `.js-funds-file[data-document-type='${selected}']`,
      );
      selectedFile.removeClass("d-none");
      this.setFileInputsRequired(
        selectedFile.find("input[type='file']"),
        true,
      );

      if (requiresBankMovements.includes(selected)) {
        const bankFile = $(
          ".js-funds-file[data-document-type='bank_movements']",
        );
        bankFile.removeClass("d-none");
        this.setFileInputsRequired(bankFile.find("input[type='file']"), true);
      }
    }

    toggleHousingFields() {
      const operation = this;
      const optionalUpdate = operation.isCustomerDetailUpdateForm();

      function toggle() {
        const housingType = $(".js-housing-type").val();
        const isRentLike =
          housingType === "rent" || housingType === "rented_room";
        const isFamily = housingType === "lives_with_family";
        const isOther = housingType === "lives_with_other";

        $("#housing_rent_fields").toggleClass("d-none", !isRentLike);
        $("#housing_rental_contract_field").toggleClass(
          "d-none",
          housingType !== "rent",
        );
        $("#housing_other_person_fields").toggleClass("d-none", !isOther);
        $("#housing_family_fields").toggleClass("d-none", !isFamily);

        // Avoid duplicate name attributes when family/other share cohabitant fields.
        $("#housing_other_person_fields input").prop("disabled", !isOther);
        $("#housing_family_fields input, #housing_family_fields select").prop(
          "disabled",
          !isFamily,
        );

        if (optionalUpdate) return;

        $("#housing_rent_fields input")
          .not("#housing_rental_contract_field input")
          .prop("required", isRentLike);
        $("#housing_rental_contract_field input").prop(
          "required",
          housingType === "rent",
        );
        $("#housing_other_person_fields input").prop("required", isOther);
        $("#housing_family_fields select, #housing_family_fields input").prop(
          "required",
          isFamily,
        );
      }

      $(".js-housing-type").on("change", toggle);
      toggle();
    }

    isCustomerDetailUpdateForm() {
      return (
        $("input[name='customer_detail[skip_callbacks]']").val() === "true"
      );
    }

    toggleFinalBeneficiaryFields() {
      const operation = this;
      const optionalUpdate = operation.isCustomerDetailUpdateForm();

      function toggle() {
        const selected = $(".js-final-beneficiary").val();
        const show = selected === "false";
        $("#final_beneficiary_fields").toggleClass("d-none", !show);
        $(
          "#final_beneficiary_fields input, #final_beneficiary_fields select",
        ).each(function () {
          const $field = $(this);
          if ($field.attr("type") === "hidden") return;
          const isOptional =
            $field.attr("name") &&
            $field.attr("name").includes("beneficiary_second_name");
          if ($field.is(":file")) {
            operation.setFileInputsRequired(
              $field,
              show && !isOptional && !optionalUpdate,
            );
            if (!show && !optionalUpdate) $field.val("");
            return;
          }
          $field.prop("required", show && !isOptional && !optionalUpdate);
          if (!show && !optionalUpdate && !$field.is(":checkbox")) {
            $field.val("");
          }
        });
      }

      $(".js-final-beneficiary").on("change", toggle);
      toggle();
    }

    validateReferencePhonesUniqueness() {
      const first = $(
        "#loan_customer_detail_attributes_first_number_reference",
      );
      const second = $(
        "#loan_customer_detail_attributes_second_number_reference",
      );
      if (!first.length || !second.length) return;

      $.validator.addMethod(
        "uniqueReferencePhone",
        function (value) {
          const other = first.val() || "";
          const normalize = (v) => (v || "").replace(/\D/g, "");
          if (!value || !other) return true;
          return normalize(value) !== normalize(other);
        },
        "El número celular no puede repetirse en las referencias personales",
      );

      second.rules("add", { uniqueReferencePhone: true });
    }

    loadDependentSelects() {
      this.loadDependentSelect(".js-profession-category", ".js-profession");
      this.loadDependentSelect(".js-occupation-category", ".js-occupation");
    }

    loadDependentSelect(parentSelector, childSelector) {
      const parent = $(parentSelector);
      const child = $(childSelector);
      if (!parent.length || !child.length) return;

      let map = {};
      try {
        map = JSON.parse(child.attr("data-options") || "{}");
      } catch (e) {
        map = {};
      }
      const placeholder = "Seleccione";

      function populate(preserveSelection) {
        const category = parent.val();
        const current = preserveSelection
          ? child.val() || child.attr("data-selected") || ""
          : "";
        const options = map[category] || [];

        child.empty();
        child.append(new Option(placeholder, "", false, false));
        options.forEach(function (pair) {
          const isSelected = pair[1] === current;
          child.append(new Option(pair[0], pair[1], isSelected, isSelected));
        });
        if (current) {
          child.val(current);
        }
        child.attr("data-selected", current);
        child.trigger("change");
      }

      parent.on("change", function () {
        populate(false);
      });
      populate(true);
    }

    populateDependentSelectChild(
      parentSelector,
      childSelector,
      category,
      selectedValue,
    ) {
      const parent = $(parentSelector);
      const child = $(childSelector);
      if (!parent.length || !child.length || !category) return;

      let map = {};
      try {
        map = JSON.parse(child.attr("data-options") || "{}");
      } catch (e) {
        map = {};
      }

      const placeholder = "Seleccione";
      const options = map[category] || [];

      parent.val(category);
      child.empty();
      child.append(new Option(placeholder, "", false, false));
      options.forEach(function (pair) {
        const isSelected = pair[1] === selectedValue;
        child.append(new Option(pair[0], pair[1], isSelected, isSelected));
      });
      if (selectedValue) {
        child.val(selectedValue);
      }
      child.attr("data-selected", selectedValue || "");
      parent.trigger("change.select2");
      child.trigger("change.select2");
    }

    refreshSelect2(selector) {
      $(selector).trigger("change.select2");
    }

    restoreEmploymentDetailFields(customerDetail) {
      if (!customerDetail) return;

      const operation = this;

      [
        "monthly_income",
        "employer_name",
        "job_title",
        "cellphone_number",
      ].forEach(function (key) {
        const value = customerDetail[key];
        if (value === undefined || value === null || value === "") return;

        const selector = {
          monthly_income: operation.ui.customerMonthlyIncome,
          employer_name: operation.ui.customerEmployerName,
          job_title: operation.ui.customerJobTitle,
          cellphone_number: operation.ui.customerCellphone,
        }[key];

        $(selector).val(value);
      });

      if (customerDetail["work_activity"]) {
        $(operation.ui.customerWorkActivity)
          .val(customerDetail["work_activity"])
          .trigger("change")
          .trigger("change.select2");
      }

      if (customerDetail["origen_recursos"]) {
        $(operation.ui.customerOrigenRecursos)
          .val(customerDetail["origen_recursos"])
          .trigger("change.select2");
      }

      if (customerDetail["profession_category"]) {
        $(operation.ui.customerProfessionCategory)
          .val(customerDetail["profession_category"])
          .trigger("change")
          .trigger("change.select2");
      }
    }

    loadExistingCustomerOnInit() {
      const operation = this;
      const dni = $(operation.ui.customerIdNumber).val();
      if (!dni) return;

      $.ajax({
        method: "GET",
        url: "/js_load_existing_customer",
        data: { dni: dni },
      }).done(function (data) {
        if (!data.result || !data.result.customer_detail) return;

        operation.restoreEmploymentDetailFields(data.result.customer_detail);
      });
    }

    configure() {
      // BY ID
      this.ui.companyID = "#loan_company_id";
      this.ui.phoneImei = "#loan_details_phone_loan_attributes_imei";
      this.ui.phoneImeiConfirmation =
        "#loan_details_phone_loan_attributes_imei_confirmation";
      this.ui.customerId = "#loan_customer_attributes_id";
      this.ui.customerFirstName = "#loan_customer_attributes_first_name";
      this.ui.customerSecondName = "#loan_customer_attributes_second_name";
      this.ui.customerFirstLastName =
        "#loan_customer_attributes_first_last_name";
      this.ui.customerSecondLastName =
        "#loan_customer_attributes_second_last_name";
      this.ui.customerEmail = "#loan_customer_detail_attributes_email";
      this.ui.customerReferenceName1 =
        "#loan_customer_detail_attributes_first_fullname_reference";
      this.ui.customerReferenceNumber1 =
        "#loan_customer_detail_attributes_first_number_reference";
      this.ui.customerReferenceName2 =
        "#loan_customer_detail_attributes_second_fullname_reference";
      this.ui.customerReferenceNumber2 =
        "#loan_customer_detail_attributes_second_number_reference";
      this.ui.customerIdNumber = "#loan_customer_attributes_id_number";
      this.ui.customerIdNumberConfirmation =
        "#loan_customer_attributes_id_number_confirmation";
      this.ui.customerBirthDate = "#loan_customer_attributes_birth_date";
      this.ui.customerGender = "#loan_customer_attributes_gender";
      this.ui.customerBirthCountry = "#loan_customer_attributes_birth_country";
      this.ui.customerHasSecondNationality =
        "#loan_customer_attributes_has_second_nationality";
      this.ui.customerSecondNationalityCountry =
        "#loan_customer_attributes_second_nationality_country";
      this.ui.customerProvinceId =
        "#loan_customer_detail_attributes_province_id";
      this.ui.customerDistrictId =
        "#loan_customer_detail_attributes_district_id";
      this.ui.customerJurisdictionId =
        "#loan_customer_detail_attributes_jurisdiction_id";
      this.ui.customerStreet =
        "#loan_customer_detail_attributes_address_street";
      this.ui.customerHomeName =
        "#loan_customer_detail_attributes_address_house_name";
      this.ui.customerHouseNumber =
        "#loan_customer_detail_attributes_address_house_number";
      this.ui.customerMaritalStatus =
        "#loan_customer_detail_attributes_marital_status";
      this.ui.customerPhotoFront =
        "#loan_customer_detail_attributes_id_photo_front";
      this.ui.customerPhotoBack =
        "#loan_customer_detail_attributes_id_photo_back";
      this.ui.customerPhotoWithUser =
        "#loan_customer_detail_attributes_id_photo_with_user";
      this.ui.customerSelfie = "#loan_customer_detail_attributes_selfie";
      this.ui.customerPhotoFrontTemp = "#photo_front_temp";
      this.ui.customerPhotoBackTemp = "#photo_back_temp";
      this.ui.customerSelfieTemp = "#photo_selfie_temp";
      this.ui.customerCellphone =
        "#loan_customer_detail_attributes_cellphone_number";
      this.ui.customerWorkActivity =
        "#loan_customer_detail_attributes_work_activity, #customer_detail_work_activity";
      this.ui.customerProfessionCategory =
        "#loan_customer_detail_attributes_profession_category, #customer_detail_profession_category";
      this.ui.customerProfession =
        "#loan_customer_detail_attributes_profession, #customer_detail_profession";
      this.ui.customerOccupationCategory =
        "#loan_customer_detail_attributes_occupation_category, #customer_detail_occupation_category";
      this.ui.customerOccupation =
        "#loan_customer_detail_attributes_occupation, #customer_detail_occupation";
      this.ui.customerOrigenRecursos =
        "#loan_customer_detail_attributes_origen_recursos, #customer_detail_origen_recursos";
      this.ui.customerMonthlyIncome =
        "#loan_customer_detail_attributes_monthly_income, #customer_detail_monthly_income";
      this.ui.customerEmployerName =
        "#loan_customer_detail_attributes_employer_name, #customer_detail_employer_name";
      this.ui.customerJobTitle =
        "#loan_customer_detail_attributes_job_title, #customer_detail_job_title";
      this.ui.customerEmployeeContainer = "#employee_fields";
      this.ui.customerSwtich0 = "#customSwitch0";
      this.ui.customerSwtich1 = "#customSwitch1";
      this.ui.customerSwtich2 = "#customSwitch2";
      this.ui.customerSwtich3 = "#customSwitch3";

      this.ui.deviceBrandId = "#device_brand_id";
      this.ui.devicePrice = "#loan_details_phone_loan_attributes_device_price";
      this.ui.percentageCompost =
        "input[name*='[percentage_compost_id]']:checked";
      this.ui.deviceModelId =
        "#loan_details_phone_loan_attributes_device_model_id";
      this.ui.paymentPeriodId =
        "input[name*='[payment_period_id]']:checked, input[name*='[payment_period]']:checked";
      this.ui.paymentPeriodWithoutChecked =
        "input[name*='[payment_period_id]'], input[name*='[payment_period]']";
      this.ui.paymentType =
        "input[name='loan[payment_type]']:checked, #loan_payment_type";
      this.ui.customerFamilyPepFunctionsOtherContainer =
        "#family_pep_function_other_field";
      this.ui.paymentTypeWithoutChecked =
        "input[name='loan[payment_type]'], #loan_payment_type";
      this.ui.loanAmount = "#loan_loan_amount";
      this.ui.result = "#result";
      this.ui.letterPreview = "#letter_preview";
      this.ui.loanCustomerNationality = "#loan_customer_attributes_nationality";
      this.ui.loanCustomerNationalityCountry =
        "#loan_customer_attributes_nationality_country";

      // PEP
      this.ui.customerIsPep = "#loan_customer_detail_attributes_is_pep";
      this.ui.customerPepContainer = "#pep_fields";
      this.ui.customerPepFunctionsOtherContainer = "#pep_function_other_field";
      this.ui.customerFamilyIsPep =
        "#loan_customer_detail_attributes_family_is_pep";
      this.ui.customerFamilyPepContainer = "#family_pep_fields";
      this.ui.customerFamilyPepRelationship =
        "#loan_customer_detail_attributes_family_pep_relationship";
      this.ui.customerFamilyPepRelationshipOtherContainer =
        "#family_pep_relationship_other_field";

      // BY Class
      this.ui.jsRootWeb = ".js-root-web";
      this.ui.jsCompany = ".js-company";
      this.ui.jsValidateDNI = ".js-validate-dni";
      this.ui.jsDevicePriceITBMS = ".js-device-price-itbms";
      this.ui.jsValidateUser = ".js-validate-user";

      // Step 3

      // Step 4
      this.ui.jsDevice = ".js-device";
      this.ui.jsFirstPaymentDate = ".js-first-payment-date";
      this.ui.jsLastPaymentDate = ".js-last-payment-date";
      this.ui.jsLetterQuantity = ".js-letter-quantity";
      this.ui.jsPaymentType = ".js-payment-type";
      this.ui.jsLetterPreview = ".js-letter-preview";

      this.ui.jsDevicePrice = ".js-device-price";
      this.ui.jsITBMS = ".js-itbms";
      this.ui.jsTotal = ".js-total";
      this.ui.jsInitialCompost = ".js-initial-compost";
      this.ui.jsLoanAmount = ".js-loan-amount";
      this.ui.jsPaymentLetter = ".js-payment-letter";
      this.ui.jsInterestCost = ".js-interest-cost";
      this.ui.jsTotalPayment = ".js-total-payment";
      this.ui.jsNextButton = "button.step_button--next";
      this.ui.jsFrontPhonto = ".js-front-photo";
      this.ui.jsBackPhoto = ".js-back-photo";
      this.ui.jsCustomerPhoto = ".js-customer-photo";
      this.ui.jsCustomerSelfie = ".js-customer-selfie";
      this.ui.jsFormMovileLoan = ".form-movile-loan";
      this.ui.jsInitialCompostPreview = ".js-initial-compost-preview";

      // step 5 - Datacultr
      this.ui.validateBtn = ".step_validate_datacultr";
      this.ui.loader = ".js-loading";
    }

    loadComponents() {
      // Safe patch for $.fn.valid to avoid this[0] is undefined errors on empty elements
      if ($.fn && $.fn.valid && !$.fn.valid._patchedForEmpty) {
        const originalValid = $.fn.valid;
        $.fn.valid = function() {
          if (this.length === 0) return true;
          return originalValid.apply(this, arguments);
        };
        $.fn.valid._patchedForEmpty = true;
      }
      this.configure();

      $("input[name*='[percentage_compost_id]']").first().prop("checked", true);
      var $paymentTypeRadios = $("input[name*='[payment_type]']");
      var $biweeklyPaymentType = $paymentTypeRadios.filter("[value='biweekly']");
      if ($biweeklyPaymentType.length) {
        $biweeklyPaymentType.prop("checked", true);
      } else {
        $paymentTypeRadios.first().prop("checked", true);
      }

      this.needFormValidation();
      this.textUpperCase();
      this.loadSelect2();
      this.loadSelect2Cascade(
        "#device_brand_id",
        "#loan_details_phone_loan_attributes_device_model_id",
      );
      this.loadSelect2Cascade(
        "#loan_customer_detail_attributes_province_id",
        "#loan_customer_detail_attributes_district_id",
      );
      this.loadSelect2Cascade(
        "#loan_customer_detail_attributes_district_id",
        "#loan_customer_detail_attributes_jurisdiction_id",
      );
      this.loadSelect2Cascade(
        "#loan_customer_detail_attributes_work_province_id",
        "#loan_customer_detail_attributes_work_district_id",
      );
      this.loadSelect2Cascade(
        "#loan_customer_detail_attributes_work_district_id",
        "#loan_customer_detail_attributes_work_jurisdiction_id",
      );
      this.loadBrandsMaxPrice();
      this.onlyLetter();
      this.onlyNumber();
      this.maskedNumber();
      this.calculateSum();
      this.validateDNI();
      this.validateUser(true);
      this.prepareLoanDescription();
      this.changeLabelOnNationality();
      this.toggleNationalityCountry();
      this.toggleSecondNationalityField();
      // Dedupe only — server already rendered unique country options.
      this.syncPanamaBirthCountryOptions(false);
      this.togglePepFields();
      this.toggleEmployeeFields();
      this.bindProfessionHelpModal();
      this.toggleHousingFields();
      this.toggleFinalBeneficiaryFields();
      this.loadDependentSelects();
      this.loadExistingCustomerOnInit();
      this.addValidatorDevicePrice();
      this.wizardStepValidation();
      this.bindWizardInvalidSubmitHandler();
      this.bindLoanFinalSubmit();
      this.validateReferencePhonesUniqueness();
      this.loadCompanyID();
      this.bindDatacultrValidation();
      this.loadCustomerAgeDisplay();

      if (
        gon.global["integration_type"]["equality"] ||
        gon.veriff_available
      ) {
        this.convertImgToBase64(
          this.ui.customerPhotoFront,
          this.ui.customerPhotoFrontTemp,
        );
        this.convertImgToBase64(
          this.ui.customerPhotoBack,
          this.ui.customerPhotoBackTemp,
        );
        this.convertImgToBase64(
          this.ui.customerSelfie,
          this.ui.customerSelfieTemp,
        );
        this.addValidatorIdentity();
        this.addValidatorIdentityPhotos();
      }

      if (document.documentElement.lang == "es_nic") {
        this.loanPaymentType();
        $(this.ui.paymentTypeWithoutChecked).change();
      }

      $(this.ui.devicePrice).blur();

      $("#loan_customer_detail_attributes_cellphone_number").rules("add", {
        validateCellphone: { loan_id: "true" },
      });

      $("#loan_customer_detail_attributes_first_number_reference").rules(
        "add",
        {
          validateCellphoneReference: true,
        },
      );

      $("#loan_customer_detail_attributes_second_number_reference").rules(
        "add",
        {
          validateCellphoneReference: true,
        },
      );
    }

    loadDataCompanyID() {
      const operation = this;
      var options = $(operation.ui.companyID).find("option");

      options.each(function (idx, element) {
        var initialPayment = element.dataset["initialPayment"];
        $(this).data("initial-payment", initialPayment);
        $(element).removeAttr("data-initial-payment");
      });
    }

    loadCompanyID() {
      const operation = this;
      $(operation.ui.companyID).on("change", function () {
        $(operation.ui.deviceBrandId).change();
      });
    }

    loadBrandsMaxPrice() {
      const operation = this;

      $(operation.ui.deviceBrandId).on("change", function () {
        var selected = parseInt($(this).find("option:selected").val());
        var devices = $(".js-root-web").data("approvedDevices");
        var company_id = parseInt(
          $(operation.ui.companyID).find("option:selected").val(),
        );
        $(this).data("query", "");
        if (Object.keys(devices).length !== 0) {
          var matching = devices.filter(function (device) {
            return (
              device.brands.includes(selected) || device.brands.length === 0
            );
          });
          if (!matching.length) {
            $(this).data("query", JSON.stringify({ company_id: company_id }));
            return;
          }
          var device = matching.reduce(function (max, current) {
            return current.max_amount > max.max_amount ? current : max;
          });

          $(this).data(
            "query",
            JSON.stringify({ max_price: device["max_amount"] }),
          );
          operation.loadInitialPayments(device);
        } else {
          $(this).data("query", JSON.stringify({ company_id: company_id }));
        }
      });
    }

    loadInitialPayments(deviceSelected) {
      $("input[name*='[percentage_compost_id]']").each(function (idx, element) {
        $(element).addClass("d-none");
        $(element).closest(".form-check").addClass("d-none");
      });

      if (deviceSelected["initial_payments"].length === 0) {
        $("input[name*='[percentage_compost_id]']").each(
          function (idx, element) {
            $(element).removeClass("d-none");
            $(element).closest(".form-check").removeClass("d-none");
          },
        );
      } else {
        for (const initial_payment of deviceSelected["initial_payments"]) {
          var element = $(
            "input[name*='[percentage_compost_id]'][data-id='" +
              initial_payment +
              "']",
          );
          $(element).removeClass("d-none");
          $(element).closest(".form-check").removeClass("d-none");
        }
      }

      $("input[name*='[percentage_compost_id]']:not(.d-none):visible")
        .first()
        .prop("checked", true);
    }

    loanPaymentType() {
      const operation = this;
      $(operation.ui.paymentTypeWithoutChecked).on("change", function () {
        payment_type = $(operation.ui.paymentType).val();

        $(operation.ui.paymentPeriodWithoutChecked).each(
          function (idx, element) {
            var value = $(element).data("value");
            var quantity = 0;

            if (payment_type == "weekly") {
              quantity = 4 * value;
            } else if (payment_type == "monthly") {
              quantity = value;
            } else {
              quantity = 2 * value;
            }

            $(element)
              .closest(".form-check")
              .find("label")
              .html(
                i18n.t("payment_period." + payment_type, { count: quantity }),
              );
          },
        );
      });
    }

    calculateDevicePriceWithoutITBMS() {
      const itbms = Number($(this.ui.jsRootWeb).data("tax") / 100) + 1;
      var device_price = Number(
        $(this.ui.devicePrice).val().replaceAll(",", ""),
      );
      var device_price_without_itbms = (device_price / itbms).toFixed(2);
      return Number(device_price_without_itbms);
    }

    calculateITBMS() {
      const operation = this;
      var country_tax = Number($(this.ui.jsRootWeb).data("tax") / 100);
      var device_price = operation.calculateDevicePriceWithoutITBMS();
      var itbms = (device_price * country_tax).toFixed(2);
      return Number(itbms);
    }

    calculateDevicePrice() {
      var device_price = Number(
        $(this.ui.devicePrice).val().replaceAll(",", ""),
      ).toFixed(2);
      return Number(device_price);
    }

    calculateLoanAmount() {
      const operation = this;
      var price = operation.calculateDevicePrice();
      var percentage_compost = Number(
        $(operation.ui.percentageCompost).data("value"),
      );
      var loan_amount = (price - price * (percentage_compost / 100)).toFixed(2);

      return Number(loan_amount);
    }

    calculateInitialCompost() {
      const operation = this;
      var price = operation.calculateDevicePrice();
      var percentage_compost = Number(
        $(operation.ui.percentageCompost).data("value"),
      );
      var initial_compost = (price * (percentage_compost / 100)).toFixed(2);

      $(operation.ui.jsInitialCompostPreview).text(
        Number(initial_compost).format(),
      );
    }

    calculateSum() {
      const operation = this;

      $(operation.ui.devicePrice).on("blur", function () {
        var price_without_itbms = operation.calculateDevicePriceWithoutITBMS();
        var loan_amount = operation.calculateLoanAmount();

        $(operation.ui.result).val(loan_amount);
        $(operation.ui.loanAmount).val(loan_amount);
        $(operation.ui.jsDevicePriceITBMS).text(price_without_itbms.format());
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });

      $(document).on("input", ".custom-percentage-compost", function () {
        var loan_amount = operation.calculateLoanAmount();
        $(operation.ui.result).val(loan_amount);
        $(operation.ui.loanAmount).val(loan_amount);
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });

      $(document).on("input", "#loan_payment_period_id", function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });

      $(operation.ui.customerBirthDate).on("blur", function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });

      $(operation.ui.customerGender).on("blur", function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });
    }

    calculateSumStepAPC() {
      // Posible Dead Code
      const operation = this;

      $(operation.ui.devicePrice).on("blur", function () {
        var loan_amount = operation.calculateLoanAmount();
        $(operation.ui.result).val(loan_amount);
        operation.calculateInitialCompost();
        operation.calculateLetterPreview();
      });

      $(document).on("input", ".custom-percentage-compost", function () {
        var loan_amount = operation.calculateLoanAmount();
        $(operation.ui.result).val(loan_amount);
        operation.calculateInitialCompost();
        operation.calculateLetterPreview();
      });

      $(document).on("input", "#loan_payment_period_id", function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });

      $(operation.ui.customerBirthDate).on("blur", function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });

      $(operation.ui.customerGender).on("blur", function () {
        operation.calculateLetterPreview();
        operation.calculateInitialCompost();
      });
    }

    calculateLastPaymentDate(initialPaymentDate, letterQuantity) {
      const operation = this;
      var frecuency = $(operation.ui.paymentType).val();
      var item = new CalculatorLoanDates(initialPaymentDate);

      if (frecuency == "weekly") {
        return moment(item.calculateWeekly(letterQuantity)).format(
          "DD/MM/YYYY",
        );
      } else if (frecuency == "monthly") {
        return moment(item.calculateMonthly(letterQuantity)).format(
          "DD/MM/YYYY",
        );
      } else {
        return moment(item.calculateBiweekly(letterQuantity)).format(
          "DD/MM/YYYY",
        );
      }
    }

    validateDNI() {
      const operation = this;

      $(operation.ui.jsValidateDNI).on("blur", function () {
        var dni = this.value;
        $.ajax({
          method: "GET",
          url: "/js_validate_unique_loan",
          data: { dni: dni },
        })
          .done(function (data) {
            console.log("done");
            if (typeof data !== "undefined") {
              if (data.status) {
                bootbox.alert({
                  message: data.messages,
                });
              }
            }
          })
          .fail(function () {
            console.log("error");
          });
      });
    }

    validateUser(allFields) {
      const operation = this;
      $(operation.ui.jsValidateUser).on("blur", function () {
        var dni = this.value;
        operation.resetFillForm(allFields);

        $.ajax({
          method: "GET",
          url: "/js_load_existing_customer",
          data: { dni: dni },
        })
          .done(function (data) {
            var customer = data.result["customer"];
            var customerDetail = data.result["customer_detail"];
            operation.fillForm(allFields, customer, customerDetail);
          })
          .fail(function () {});
      });
    }

    resetFillForm(allFields) {
      const operation = this;
      $(operation.ui.customerId).val("");
      $(operation.ui.customerFirstName).val("");
      $(operation.ui.customerFirstLastName).val("");
      $(operation.ui.customerBirthDate).val("");
      $(operation.ui.customerGender).val("");
      operation.updateCustomerAgeDisplay();

      if (allFields) {
        $(operation.ui.customerSecondName).val("");
        $(operation.ui.customerSecondLastName).val("");
        $(operation.ui.customerEmail).val("");
        $(operation.ui.customerReferenceName1).val("");
        $(operation.ui.customerReferenceNumber1).val("");
        $(operation.ui.customerReferenceName2).val("");
        $(operation.ui.customerReferenceNumber2).val("");
        $(operation.ui.customerProvinceId).val(null).trigger("change");
        $(operation.ui.customerDistrictId).val(null).trigger("change");
        $(operation.ui.customerJurisdictionId).val(null).trigger("change");
        $(operation.ui.customerStreet).val("");
        $(operation.ui.customerHomeName).val("");
        $(operation.ui.customerHouseNumber).val("");
        $(operation.ui.customerMaritalStatus).val("");
        $(operation.ui.customerWorkActivity).val(null).trigger("change");
        $(operation.ui.customerProfessionCategory).val(null).trigger("change");
        $(operation.ui.customerProfession)
          .val(null)
          .attr("data-selected", "")
          .trigger("change");
        $(operation.ui.customerOccupationCategory).val(null).trigger("change");
        $(operation.ui.customerOccupation)
          .val(null)
          .attr("data-selected", "")
          .trigger("change");
        $(operation.ui.customerOrigenRecursos).val(null).trigger("change");
        $(operation.ui.customerMonthlyIncome).val("");
        $(operation.ui.customerEmployerName).val("");
        $(operation.ui.customerJobTitle).val("");
        $(operation.ui.customerCellphone).val("");
      }
    }

    fillForm(allFields, customer, customerDetail) {
      const operation = this;
      $(operation.ui.customerId).val(customer["id"]);
      $(operation.ui.customerFirstName).val(customer["first_name"]);
      $(operation.ui.customerFirstLastName).val(customer["first_last_name"]);
      $(operation.ui.customerBirthDate).val(customer["birth_date"]);
      $(operation.ui.customerGender).val(customer["gender"]);
      if (customer["nit"]) {
        $("#loan_customer_attributes_nit").val(customer["nit"]);
        $("#loan_customer_attributes_nit_confirmation").val(customer["nit"]);
      }
      operation.updateCustomerAgeDisplay();

      if (allFields) {
        $(operation.ui.customerSecondName).val(customer["second_name"]);
        $(operation.ui.customerSecondLastName).val(
          customer["second_last_name"],
        );

        if (customerDetail) {
          $(operation.ui.customerEmail).val(customerDetail["email"]);
          $(operation.ui.customerReferenceName1).val(
            customerDetail["first_fullname_reference"],
          );
          $(operation.ui.customerReferenceNumber1).val(
            customerDetail["first_number_reference"],
          );
          $(operation.ui.customerReferenceName2).val(
            customerDetail["second_fullname_reference"],
          );
          $(operation.ui.customerReferenceNumber2).val(
            customerDetail["second_number_reference"],
          );
          $(operation.ui.customerProvinceId)
            .val(customerDetail["province_id"])
            .trigger("change");
          operation.addOptionSelect2(
            operation.ui.customerDistrictId,
            customerDetail["district_option_for_select"],
          );
          operation.addOptionSelect2(
            operation.ui.customerJurisdictionId,
            customerDetail["jurisdiction_option_for_select"],
          );
          $(operation.ui.customerStreet).val(customerDetail["address_street"]);
          $(operation.ui.customerHomeName).val(
            customerDetail["address_house_name"],
          );
          $(operation.ui.customerHouseNumber).val(
            customerDetail["address_house_number"],
          );
          $(operation.ui.customerMaritalStatus).val(
            customerDetail["marital_status"],
          );
          operation.restoreEmploymentDetailFields(customerDetail);
        }
      }
    }

    prepareLoanDescription() {
      const operation = this;
      $(operation.ui.jsNextButton).on("click", function () {
        var interest = operation.getInterest();
        // Panama UI brands the installment as quincenal (letter_preview locales).
        var paymentTypeKey = $(operation.ui.paymentType).val();
        if (["es_pan", "es_pan_lsg"].includes(document.documentElement.lang)) {
          paymentTypeKey = "biweekly";
        }
        var payment_type = i18n.t(
          "activerecord.enums.loan.payment_types." + paymentTypeKey,
        );
        var period_quantity = operation.getPaymentPeriod();
        var frecuency = operation.getPaymentFrecuency();
        var letter_quantity = frecuency * period_quantity;
        var initial_payment_date = operation.getInitialPaymentDate();
        var first_payment = initial_payment_date.format("DD/MM/YYYY");
        var last_payment = operation.calculateLastPaymentDate(
          initial_payment_date,
          letter_quantity,
        );
        var device_price = operation.calculateDevicePrice();
        var loan_amount = operation.calculateLoanAmount();
        var device_price_without_itbms =
          operation.calculateDevicePriceWithoutITBMS();
        var itbms = operation.calculateITBMS();
        var interest_cost = interest * loan_amount * period_quantity;
        var total_payment = loan_amount + interest_cost;
        //var letter_payment = total_payment / letter_quantity;

        $(operation.ui.jsDevice).text(
          $(operation.ui.deviceModelId).find("option:selected").text(),
        );
        $(operation.ui.jsFirstPaymentDate).text(first_payment);
        $(operation.ui.jsLastPaymentDate).text(last_payment);
        $(operation.ui.jsLetterQuantity).text(letter_quantity);
        $(operation.ui.jsPaymentType).text(payment_type);

        // Calculate
        $(operation.ui.jsDevicePrice).text(device_price_without_itbms.format());
        $(operation.ui.jsITBMS).text(itbms.format());
        $(operation.ui.jsTotal).text((device_price * 1.0).format());
        $(operation.ui.jsInitialCompost).text(
          ((device_price - loan_amount) * 1.0).format(),
        );
        $(operation.ui.jsLoanAmount).text(loan_amount.format());
        //$(operation.ui.jsInterestCost).text(interest_cost.toFixed(2));
        //$(operation.ui.jsTotalPayment).text(total_payment.toFixed(2));
        //$(operation.ui.jsPaymentLetter).text(Math.ceil(letter_payment).toFixed(2));
      });
    }

    calculateLetterPreview() {
      const operation = this;
      var interest = operation.getInterest();
      var period_quantity = operation.getPaymentPeriod();
      var frecuency = operation.getPaymentFrecuency();
      var letter_quantity = frecuency * period_quantity;
      var loan_amount = Number(
        $(operation.ui.result).val().replaceAll(",", ""),
      );
      var interest_cost = interest * loan_amount * period_quantity;
      var total_payment = loan_amount + interest_cost;
      var letter_payment = total_payment / letter_quantity;

      if (gon.global.same_currency) {
        $(operation.ui.jsPaymentLetter).text(
          Math.ceil(letter_payment).toFixed(2),
        );
        $(operation.ui.jsLetterPreview).text(
          Math.ceil(letter_payment).toFixed(2),
        );
        $(operation.ui.letterPreview).val(Math.ceil(letter_payment).toFixed(2));
      } else {
        var exchangeRate = Number(
          $(operation.ui.jsRootWeb).data("exchange-rate"),
        );
        loan_amount = loan_amount / exchangeRate;
        interest_cost = interest_cost / exchangeRate;
        total_payment = total_payment / exchangeRate;
        letter_payment = total_payment / letter_quantity;
        letter_payment = (Math.ceil(letter_payment) * exchangeRate).toFixed(2);

        $(operation.ui.jsPaymentLetter).text(letter_payment);
        $(operation.ui.jsLetterPreview).text(letter_payment);
        $(operation.ui.letterPreview).val(letter_payment);
      }
    }

    changeLabelOnNationality() {
      const operation = this;
      $(operation.ui.loanCustomerNationality).on("change", function () {
        var selected = $(this).val();

        operation.getLabelNationality(selected);

        if ($(operation.ui.customerIdNumber).val() != "") {
          $(operation.ui.customerIdNumber).valid();
        }
      });

      const selected = $(operation.ui.loanCustomerNationality).val();
      if (selected) operation.getLabelNationality(selected);
    }

    loanDocumentLabel(key) {
      const locale = document.documentElement.lang;
      const labelsByLocale = {
        es_pan: {
          fullname: "Cédula",
          confimfullname: "Confirme Cédula",
          passport: "Pasaporte",
          confirmpassport: "Confirme Pasaporte",
        },
        es_gtm: {
          fullname: "Número de DPI o Pasaporte",
          confimfullname: "Confirme número de DPI o pasaporte",
          passport: "Pasaporte",
          confirmpassport: "Confirme Pasaporte",
        },
        es_gtm_lsg: {
          fullname: "Número de DPI o Pasaporte",
          confimfullname: "Confirme número de DPI o pasaporte",
          passport: "Pasaporte",
          confirmpassport: "Confirme Pasaporte",
        },
        es_slv: {
          fullname: "Número de DUI o pasaporte",
          confimfullname: "Confirme número de DUI o pasaporte",
          passport: "Pasaporte",
          confirmpassport: "Confirme Pasaporte",
        },
        es_slv_lsg: {
          fullname: "Número de DUI o pasaporte",
          confimfullname: "Confirme número de DUI o pasaporte",
          passport: "Pasaporte",
          confirmpassport: "Confirme Pasaporte",
        },
        es_nic: {
          fullname: "Número de Cédula o pasaporte",
          confimfullname: "Confirme número de Cédula o pasaporte",
          passport: "Pasaporte",
          confirmpassport: "Confirme Pasaporte",
        },
        es_hnd: {
          fullname: "Número de Cédula o pasaporte",
          confimfullname: "Confirme número de Cédula o pasaporte",
          passport: "Pasaporte",
          confirmpassport: "Confirme Pasaporte",
        },
        es_pry: {
          fullname: "Número de Cédula o pasaporte",
          confimfullname: "Confirme número de Cédula o pasaporte",
          passport: "Pasaporte",
          confirmpassport: "Confirme Pasaporte",
        },
      };

      return labelsByLocale[locale]?.[key] || i18n.t(`loans.${key}`);
    }

    getLabelNationality(selected) {
      const operation = this;
      const isPanama = document.documentElement.lang === "es_pan";

      if (selected == "national") {
        $(operation.ui.customerIdNumber).addClass("formatDNI");
        $(operation.ui.customerIdNumber).rules("add", { formatDNI: true });
        $(operation.ui.jsFrontPhonto).text(
          i18n.t("activerecord.attributes.customer_detail.id_photo_front"),
        );
        $(operation.ui.jsBackPhoto).text(
          i18n.t("activerecord.attributes.customer_detail.id_photo_back"),
        );
        $(operation.ui.jsCustomerPhoto).text(
          i18n.t("activerecord.attributes.customer_detail.id_photo_with_user"),
        );
        // Hardcode locale-specific ID labels to avoid translation issues
        const idLabelsByLocale = {
          es_pan: { fullname: "Cédula", confimfullname: "Confirme Cédula" },
          es_gtm: {
            fullname: "Número de DPI o Pasaporte",
            confimfullname: "Confirme número de DPI o pasaporte",
          },
          es_gtm_lsg: {
            fullname: "Número de DPI o Pasaporte",
            confimfullname: "Confirme número de DPI o pasaporte",
          },
        };
        const idLabels = idLabelsByLocale[document.documentElement.lang] || {
          fullname: i18n.t("loans.fullname"),
          confimfullname: i18n.t("loans.confimfullname"),
        };
        $(`label[for="${operation.ui.customerIdNumber.substring(1)}"]`).text(
          idLabels.fullname,
        );
        $(
          `label[for="${operation.ui.customerIdNumberConfirmation.substring(1)}"]`,
        ).text(idLabels.confimfullname);
      } else if (selected == "naturalized" && isPanama) {
        $(operation.ui.customerIdNumber).addClass("formatDNI");
        $(operation.ui.customerIdNumber).rules("add", { formatDNI: true });
        $(operation.ui.jsFrontPhonto).text("Foto frontal de la Cédula PN");
        $(operation.ui.jsBackPhoto).text("Foto trasera de la Cédula PN");
        $(operation.ui.jsCustomerPhoto).text(
          "Foto del cliente con la Cédula PN",
        );
        $(`label[for="${operation.ui.customerIdNumber.substring(1)}"]`).text(
          "Cédula PN",
        );
        $(
          `label[for="${operation.ui.customerIdNumberConfirmation.substring(1)}"]`,
        ).text("Confirme Cédula PN");
      } else if (isPanama) {
        $(operation.ui.customerIdNumber).addClass("formatDNI");
        $(operation.ui.customerIdNumber).rules("add", { formatDNI: true });
        $(operation.ui.jsFrontPhonto).text("Foto frontal de la Cédula E");
        $(operation.ui.jsBackPhoto).text("Foto trasera de la Cédula E");
        $(operation.ui.jsCustomerPhoto).text(
          "Foto del cliente con la Cédula E",
        );
        $(`label[for="${operation.ui.customerIdNumber.substring(1)}"]`).text(
          "Cédula E",
        );
        $(
          `label[for="${operation.ui.customerIdNumberConfirmation.substring(1)}"]`,
        ).text("Confirme Cédula E");
      } else {
        $(operation.ui.customerIdNumber).removeClass("formatDNI");
        $(operation.ui.customerIdNumber).rules("remove", "formatDNI");
        $(operation.ui.jsFrontPhonto).text("Foto del pasaporte");
        $(operation.ui.jsBackPhoto).text(
          "Foto del carné de residencia (Un año de vigencia mínimo)",
        );
        $(operation.ui.jsCustomerPhoto).text(
          "Foto del cliente con el carné de residencia",
        );
        const passportLabel = operation.loanDocumentLabel("passport");
        const confirmPassportLabel =
          operation.loanDocumentLabel("confirmpassport");
        $(`label[for="${operation.ui.customerIdNumber.substring(1)}"]`).text(
          passportLabel,
        );
        $(
          `label[for="${operation.ui.customerIdNumberConfirmation.substring(1)}"]`,
        ).text(confirmPassportLabel);
      }
    }

    // Step 4 "Siguiente" creates the loan (POST). Validate first; if invalid,
    // jump to the step with errors instead of staying on the summary blankly.
    bindLoanFinalSubmit() {
      const operation = this;
      $(document)
        .off("click.loanFinalSubmit", ".js-loan-final-submit")
        .on("click.loanFinalSubmit", ".js-loan-final-submit", function (e) {
          e.preventDefault();
          const $form = $(operation.ui.jsFormMovileLoan);
          if (!$form.length) return;

          const $btn = $(this);
          if ($btn.data("submitting")) return;

          // Consent/preloaded flows disable id_number but leave confirmation blank.
          // Full-form validate then fails and revealWizardStepFor jumps to step 1.
          const $id = $(operation.ui.customerIdNumber);
          const $idConf = $(operation.ui.customerIdNumberConfirmation);
          const idVal =
            ($id.val() || "").trim() ||
            (
              $form
                .find('input[name="loan[customer_attributes][id_number]"]')
                .val() || ""
            ).trim();
          if (idVal && $idConf.length && !($idConf.val() || "").trim()) {
            $idConf.val(idVal);
          }

          if ($form.valid()) {
            $btn.data("submitting", true);
            $btn.prop("disabled", true).text(i18n.t("commons.processing"));
            // Native submit after successful jquery validate (avoids re-entry).
            HTMLFormElement.prototype.submit.call($form[0]);
            return;
          }

          const validator = $form.data("validator");
          const first = validator && validator.errorList && validator.errorList[0];
          if (first && first.element) {
            operation.revealWizardStepFor(first.element);
          }

          const fieldHint =
            first && first.element && first.element.name
              ? `<br><small>${first.element.name}</small>`
              : "";
          Swal.fire({
            icon: "error",
            html:
              "Hay campos obligatorios pendientes. Complete el paso indicado e intente de nuevo." +
              fieldHint,
            confirmButtonText: "Aceptar",
          });
        });
    }

    // When final submit fails validation on a previous (opacity:0) step,
    // focus would scroll the horizontal carousel off-screen (blank UI).
    // Jump back to the step that owns the first invalid field instead.
    bindWizardInvalidSubmitHandler() {
      const operation = this;
      const $form = $(operation.ui.jsFormMovileLoan);
      if (!$form.length) return;

      const attach = function () {
        const validator = $form.data("validator");
        if (!validator) return;
        const previous = validator.settings.invalidHandler;
        validator.settings.invalidHandler = function (event, validatorInstance) {
          if (typeof previous === "function") {
            previous.call(this, event, validatorInstance);
          }
          const first = validatorInstance.errorList[0];
          if (first && first.element) {
            operation.revealWizardStepFor(first.element);
          }
        };
      };

      attach();
      // needFormValidation may run just before this; retry once on next tick.
      setTimeout(attach, 0);
    }

    revealWizardStepFor(element) {
      const target = element && element.closest ? element.closest(".step") : null;
      if (!target) return;

      const steps = Array.from(
        document.querySelectorAll(".form-body > .step, .form-movile-loan > .step"),
      );
      if (!steps.length) return;

      const targetIdx = steps.indexOf(target);
      if (targetIdx < 0) return;

      steps.forEach(function (step, idx) {
        step.classList.remove("active", "inactive");
        if (idx < targetIdx) {
          step.classList.add("to-left");
        } else {
          step.classList.remove("to-left");
        }
      });
      target.classList.add("active");

      requestAnimationFrame(function () {
        const header = document.querySelector(".card-header-loan");
        if (header) {
          header.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        try {
          element.focus({ preventScroll: true });
        } catch (e) {
          $(element).focus();
        }
      });
    }

    // For loan v1 Validation
    wizardStepValidation() {
      const operation = this;

      $(operation.ui.phoneImeiConfirmation).rules("add", {
        equalTo: operation.ui.phoneImei,
      });

      $(operation.ui.customerIdNumberConfirmation).rules("add", {
        equalTo: operation.ui.customerIdNumber,
      });

      $("#loan_customer_attributes_nit_confirmation").rules("add", {
        equalTo: "#loan_customer_attributes_nit",
      });

      $(operation.ui.customerBirthDate).rules("add", {
        maxAge: gon.global.max_age.cellular.max,
        minAge: gon.global.max_age.cellular.min,
      });

      $(operation.ui.jsFormMovileLoan).on("click", function (e) {
        let element = e.target;
        let isButtonNext = element.classList.contains("step_button--next");
        let isButtonBack = element.classList.contains("step_button--back");
        let current_step = element.dataset.step;

        var validateField = function(selector) {
          var el = typeof selector === 'string' ? $(selector) : selector;
          return el.length === 0 ? true : el.valid();
        };

        if (current_step == 1) {
          var validForm =
            !$(operation.ui.customerIdNumber).valid() ||
            !$(operation.ui.customerIdNumberConfirmation).valid() ||
            !$(operation.ui.deviceModelId).valid() ||
            !$(operation.ui.phoneImei).valid() ||
            !$(operation.ui.phoneImeiConfirmation).valid() ||
            !$(operation.ui.devicePrice).valid() ||
            !$(operation.ui.customerBirthDate).valid() ||
            !$(operation.ui.customerGender).valid();

          if (
            ["es_pan", "es_pan_lsg"].includes(document.documentElement.lang)
          ) {
            validForm =
              validForm || !$(operation.ui.customerBirthCountry).valid();

            if ($(operation.ui.customerHasSecondNationality).val() === "true") {
              validForm =
                validForm ||
                !$(operation.ui.customerSecondNationalityCountry).valid();
            }

            if (
              $(operation.ui.loanCustomerNationality).val() === "foreigner" &&
              $("#migration_card_fields").length
            ) {
              validForm =
                validForm ||
                !$("#loan_customer_attributes_nit").valid() ||
                !$("#loan_customer_attributes_nit_confirmation").valid();
            }

            if (!validForm && !operation.validatePanamaNationalityCriteria()) {
              operation.togglePanamaNationalityAlert(true);
              return;
            }

            operation.togglePanamaNationalityAlert(false);
          }

          if (validForm) {
            $(operation.ui.customerIdNumber).valid();
            $(operation.ui.customerIdNumberConfirmation).valid();
            $(operation.ui.deviceModelId).valid();
            $(operation.ui.phoneImei).valid();
            $(operation.ui.phoneImeiConfirmation).valid();
            $(operation.ui.devicePrice).valid();
            $(operation.ui.customerBirthDate).valid();
            $(operation.ui.customerGender).valid();
            if (
              ["es_pan", "es_pan_lsg"].includes(document.documentElement.lang)
            ) {
              $(operation.ui.customerBirthCountry).valid();
              if (
                $(operation.ui.customerHasSecondNationality).val() === "true"
              ) {
                $(operation.ui.customerSecondNationalityCountry).valid();
              }
              if (
                $(operation.ui.loanCustomerNationality).val() === "foreigner" &&
                $("#migration_card_fields").length
              ) {
                $("#loan_customer_attributes_nit").valid();
                $("#loan_customer_attributes_nit_confirmation").valid();
              }
            }
            $(".js-need-validation").find(":input.is-invalid:first").focus();
            return;
          }
        } else if (current_step == 2) {
          var validForm =
            !validateField(operation.ui.customerFirstName) ||
            !validateField(operation.ui.customerFirstLastName) ||
            !validateField(operation.ui.customerSecondLastName) ||
            !validateField(operation.ui.customerEmail) ||
            !validateField(operation.ui.customerReferenceNumber1) ||
            !validateField("#loan_customer_detail_attributes_first_reference_first_name") ||
            !validateField("#loan_customer_detail_attributes_first_reference_first_last_name") ||
            !validateField("#loan_customer_detail_attributes_first_reference_second_last_name");

          if (!["es_gtm", "es_gtm_lsg"].includes(document.documentElement.lang)) {
            validForm = validForm ||
              !validateField(operation.ui.customerProvinceId) ||
              !validateField(operation.ui.customerDistrictId) ||
              !validateField(operation.ui.customerStreet) ||
              !validateField(operation.ui.customerHomeName) ||
              !validateField(operation.ui.customerHouseNumber);
          } else {
            validForm = validForm ||
              !validateField("#loan_customer_detail_attributes_gtm_department") ||
              !validateField("#loan_customer_detail_attributes_gtm_municipality") ||
              !validateField("#loan_customer_detail_attributes_gtm_neighborhood") ||
              !validateField("#loan_customer_detail_attributes_gtm_address_line") ||
              !validateField("#loan_customer_detail_attributes_building");
          }

          if (["es", "es_slv"].includes(document.documentElement.lang)) {
            validForm =
              validForm || !validateField(operation.ui.customerJurisdictionId);
          }

          if (
            ["es_pan", "es_pan_lsg"].includes(document.documentElement.lang)
          ) {
            validForm =
              validForm ||
              !$("#loan_customer_detail_attributes_contact_first_name").valid() ||
              !$("#loan_customer_detail_attributes_contact_first_last_name").valid() ||
              !$("#loan_customer_detail_attributes_contact_second_last_name").valid() ||
              !$("#loan_customer_detail_attributes_contact_id_number").valid() ||
              !$("#loan_customer_detail_attributes_contact_cellphone").valid() ||
              !$("#loan_customer_detail_attributes_contact_relationship").valid() ||
              !$("#loan_customer_detail_attributes_contact_nationality").valid() ||
              !$("#loan_customer_detail_attributes_contact_email").valid();
          }

          if (validForm) {
            var failedFields = [];
            var checkAndPush = function(selector) {
                if (!validateField(selector)) failedFields.push(selector);
            };
            checkAndPush(operation.ui.customerFirstName);
            checkAndPush(operation.ui.customerFirstLastName);
            checkAndPush(operation.ui.customerSecondLastName);
            checkAndPush(operation.ui.customerEmail);
            checkAndPush(operation.ui.customerReferenceNumber1);
            checkAndPush("#loan_customer_detail_attributes_first_reference_first_name");
            checkAndPush("#loan_customer_detail_attributes_first_reference_first_last_name");
            checkAndPush("#loan_customer_detail_attributes_first_reference_second_last_name");
            if (!["es_gtm", "es_gtm_lsg"].includes(document.documentElement.lang)) {
              checkAndPush(operation.ui.customerProvinceId);
              checkAndPush(operation.ui.customerDistrictId);
              if (["es", "es_slv"].includes(document.documentElement.lang)) {
                checkAndPush(operation.ui.customerJurisdictionId);
              }
              checkAndPush(operation.ui.customerStreet);
              checkAndPush(operation.ui.customerHomeName);
              checkAndPush(operation.ui.customerHouseNumber);
            } else {
              checkAndPush("#loan_customer_detail_attributes_gtm_department");
              checkAndPush("#loan_customer_detail_attributes_gtm_municipality");
              checkAndPush("#loan_customer_detail_attributes_gtm_neighborhood");
              checkAndPush("#loan_customer_detail_attributes_gtm_address_line");
              checkAndPush("#loan_customer_detail_attributes_building");
            }
            if (failedFields.length > 0) {
               fetch('/log_frontend_error', {
                 method: 'POST',
                 headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
                 body: JSON.stringify({ message: "Validation blocked Step 2", stack: "Failed fields: " + failedFields.join(", "), url: window.location.href })
               }).catch(e => console.error(e));
            }
            if (
              ["es_pan", "es_pan_lsg"].includes(document.documentElement.lang)
            ) {
              $("#loan_customer_detail_attributes_contact_first_name").valid();
              $("#loan_customer_detail_attributes_contact_first_last_name").valid();
              $("#loan_customer_detail_attributes_contact_second_last_name").valid();
              $("#loan_customer_detail_attributes_contact_id_number").valid();
              $("#loan_customer_detail_attributes_contact_cellphone").valid();
              $("#loan_customer_detail_attributes_contact_relationship").valid();
              $("#loan_customer_detail_attributes_contact_nationality").valid();
              $("#loan_customer_detail_attributes_contact_email").valid();
            }
            $(".js-need-validation").find(":input.is-invalid:first").focus();
            return;
          }
        } else if (current_step == 3) {
          var isVeriffAvailable = gon.veriff_available;
          var activity = $(operation.ui.customerWorkActivity).val();
          var isStudent = activity === "university_student";
          var needsWorkAddress =
            activity === "employee" || activity === "independent";
          var needsIncomeExpenses =
            activity &&
            activity !== "dependent" &&
            activity !== "university_student";

          var validForm =
            !$(operation.ui.customerCellphone).valid() ||
            !$(operation.ui.customerWorkActivity).valid();

          if (!isVeriffAvailable) {
            validForm = validForm || !$(operation.ui.customerPhotoBack).valid();
          }

          if (
            !$(".js-occupation-row").hasClass("d-none") &&
            $("#loan_customer_detail_attributes_profession_occupation").length
          ) {
            validForm =
              validForm ||
              !validateField("#loan_customer_detail_attributes_profession_occupation");
          } else if (
            !$(".js-occupation-row").hasClass("d-none") &&
            $("#loan_customer_detail_attributes_profession_text").length
          ) {
            validForm =
              validForm ||
              !validateField("#loan_customer_detail_attributes_profession_text");
          }

          if (
            !$(".js-main-activity-row").hasClass("d-none") &&
            $("#loan_customer_detail_attributes_main_activity_text").length
          ) {
            validForm =
              validForm ||
              !validateField("#loan_customer_detail_attributes_main_activity_text");
          }

          if (activity === "employee") {
            validForm =
              validForm ||
              !$(operation.ui.customerEmployerName).valid() ||
              !$(operation.ui.customerJobTitle).valid();
          }

          if (activity === "independent") {
            validForm =
              validForm || !$(operation.ui.customerEmployerName).valid();
          }

          if (activity === "university_student") {
            validForm =
              validForm ||
              !validateField(
                "#loan_customer_detail_attributes_student_career",
              );
            const studentCard = $(".js-student-card-photo")[0];
            if (studentCard && !operation.fileInputFilled(studentCard)) {
              validForm = true;
              $(studentCard).addClass("is-invalid");
            }
          }

          if (activity === "dependent") {
            validForm =
              validForm ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_first_name",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_first_last_name",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_second_last_name",
              ) ||
              !$("#loan_customer_detail_attributes_dependent_of_id_number").valid() ||
              !$("#loan_customer_detail_attributes_dependent_of_phone").valid() ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_monthly_income",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_profession_text",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_main_activity_text",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_employer_name",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_work_address",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_dependent_of_job_title",
              );
            const dependentIdPhoto = $(".js-dependent-of-id-photo")[0];
            if (
              dependentIdPhoto &&
              !operation.fileInputFilled(dependentIdPhoto)
            ) {
              validForm = true;
              $(dependentIdPhoto).addClass("is-invalid");
            }
          } else if (needsIncomeExpenses) {
            validForm =
              validForm || !$(operation.ui.customerMonthlyIncome).valid();
          }

          if (needsWorkAddress) {
            const $workAddressTextField = $(
              "#loan_customer_detail_attributes_work_address_text",
            );
            if ($workAddressTextField.length) {
              validForm =
                validForm ||
                !validateField(
                  "#loan_customer_detail_attributes_work_address_text",
                );
            } else if (["es_gtm", "es_gtm_lsg"].includes(document.documentElement.lang)) {
              validForm =
                validForm ||
                !validateField(
                  "#loan_customer_detail_attributes_gtm_work_department",
                ) ||
                !validateField(
                  "#loan_customer_detail_attributes_gtm_work_municipality",
                ) ||
                !validateField(
                  "#loan_customer_detail_attributes_gtm_work_neighborhood",
                ) ||
                !validateField(
                  "#loan_customer_detail_attributes_gtm_work_address_line",
                ) ||
                !validateField(
                  "#loan_customer_detail_attributes_gtm_work_building",
                );
            } else {
              validForm =
                validForm ||
                !validateField(
                  "#loan_customer_detail_attributes_work_province_id",
                ) ||
                !validateField(
                  "#loan_customer_detail_attributes_work_district_id",
                ) ||
                !validateField(
                  "#loan_customer_detail_attributes_work_address_street",
                ) ||
                !validateField(
                  "#loan_customer_detail_attributes_work_address_house_name",
                ) ||
                !validateField(
                  "#loan_customer_detail_attributes_work_address_house_number",
                );

              if (
                ["es_pan", "es_pan_lsg", "es_slv"].includes(
                  document.documentElement.lang,
                )
              ) {
                validForm =
                  validForm ||
                  !validateField(
                    "#loan_customer_detail_attributes_work_jurisdiction_id",
                  );
              }
            }
          }

          if (isStudent) {
            validForm =
              validForm ||
              !validateField("#loan_customer_detail_attributes_tutor_name") ||
              !validateField(
                "#loan_customer_detail_attributes_tutor_occupation",
              ) ||
              !validateField("#loan_customer_detail_attributes_tutor_phone") ||
              !validateField(
                "#loan_customer_detail_attributes_tutor_monthly_income",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_tutor_profession_text",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_tutor_main_activity_text",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_tutor_employer_name",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_tutor_work_address",
              ) ||
              !validateField(
                "#loan_customer_detail_attributes_tutor_job_title",
              );
            if (
              $("#loan_customer_detail_attributes_tutor_occupation").val() ===
              "retired"
            ) {
              const retirementCard = $(".js-retirement-card-photo")[0];
              if (
                retirementCard &&
                !operation.fileInputFilled(retirementCard)
              ) {
                validForm = true;
                $(retirementCard).addClass("is-invalid");
              }
            }
          }

          if (
            ($(".js-other-income-fields").length &&
              !$(".js-other-income-fields").hasClass("d-none")) ||
            ($(".js-other-income-row").length &&
              !$(".js-other-income-row").hasClass("d-none"))
          ) {
            validForm =
              validForm ||
              !validateField(".js-has-other-income") ||
              ($(".js-other-income-details").length &&
                !$(".js-other-income-details").hasClass("d-none") &&
                (!validateField(
                  "#loan_customer_detail_attributes_other_income_amount",
                ) ||
                  !validateField(
                    "#loan_customer_detail_attributes_other_income_frequency",
                  ) ||
                  !validateField(
                    "#loan_customer_detail_attributes_other_income_source",
                  )));
          }

          if (
            $(".js-pep-position-fields").length &&
            !$(".js-pep-position-fields").hasClass("d-none")
          ) {
            validForm =
              validForm ||
              !validateField("#loan_customer_detail_attributes_pep_position") ||
              !validateField(
                "#loan_customer_detail_attributes_pep_from_at",
              ) ||
              !validateField("#loan_customer_detail_attributes_pep_to_at");
          }

          if (
            $(".js-illicit-explanation").length &&
            !$(".js-illicit-explanation").hasClass("d-none")
          ) {
            validForm =
              validForm ||
              !validateField(
                "#loan_customer_detail_attributes_illicit_activities_explanation",
              );
          }

          if (activity === "pensioner") {
            const pensionerCard = $(".js-pensioner-card-photo")[0];
            if (
              pensionerCard &&
              !operation.fileInputFilled(pensionerCard)
            ) {
              validForm = true;
              $(pensionerCard).addClass("is-invalid");
            }
          }

          // id_photo_with_user is always manually uploaded (never from Veriff)
          validForm =
            validForm || !$(operation.ui.customerPhotoWithUser).valid();

          if (gon.global["integration_type"]["equality"] || isVeriffAvailable) {
            if (!$(operation.ui.customerSwtich0).is(":checked")) {
              if (!isVeriffAvailable) {
                validForm =
                  validForm || !$(operation.ui.customerPhotoFront).valid();
              }
            }
          } else {
            if (!isVeriffAvailable) {
              validForm =
                validForm || !$(operation.ui.customerPhotoFront).valid();
            }
          }

          // Validate funds origin document type + visible file uploads
          const $fundsSection = $("#funds_origin_section");
          if ($fundsSection.length && !$fundsSection.hasClass("d-none")) {
            const fundsType = $(".js-funds-origin-document-type").val();
            validForm = validForm || !fundsType;

            if (fundsType && fundsType !== "family_support") {
              $fundsSection
                .find('.js-funds-file:not(.d-none) input[type="file"]')
                .each(function () {
                  if (!operation.fileInputFilled(this)) {
                    validForm = true;
                    $(this).addClass("is-invalid");
                  } else {
                    $(this).removeClass("is-invalid");
                  }
                });
            }
          }

          if (validForm) {
            $(operation.ui.customerPhotoWithUser).valid();
            if (
              gon.global["integration_type"]["equality"] ||
              gon.veriff_available
            ) {
              if (!$(operation.ui.customerSwtich0).is(":checked")) {
                if (!isVeriffAvailable) {
                  $(operation.ui.customerPhotoFront).valid();
                }
              }
            } else {
              if (!isVeriffAvailable) {
                $(operation.ui.customerPhotoFront).valid();
              }
            }
            if (!isVeriffAvailable) {
              $(operation.ui.customerPhotoBack).valid();
            }
            $(operation.ui.customerCellphone).valid();
            $(operation.ui.customerWorkActivity).valid();
            if (needsIncomeExpenses) {
              $(operation.ui.customerMonthlyIncome).valid();
            }
            if (activity === "dependent") {
              $(
                "#loan_customer_detail_attributes_dependent_of_first_name",
              ).valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_first_last_name",
              ).valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_second_last_name",
              ).valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_id_number",
              ).valid();
              $("#loan_customer_detail_attributes_dependent_of_phone").valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_monthly_income",
              ).valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_profession_text",
              ).valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_main_activity_text",
              ).valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_employer_name",
              ).valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_work_address",
              ).valid();
              $(
                "#loan_customer_detail_attributes_dependent_of_job_title",
              ).valid();
            }

            if (activity === "employee") {
              $(operation.ui.customerEmployerName).valid();
              $(operation.ui.customerJobTitle).valid();
            }
            if (activity === "independent") {
              $(operation.ui.customerEmployerName).valid();
            }

            if (needsWorkAddress) {
              const $workAddressTextField = $(
                "#loan_customer_detail_attributes_work_address_text",
              );
              if ($workAddressTextField.length) {
                $workAddressTextField.valid();
              } else {
                $("#loan_customer_detail_attributes_work_province_id").valid();
                $("#loan_customer_detail_attributes_work_district_id").valid();
                $("#loan_customer_detail_attributes_work_address_street").valid();
                $(
                  "#loan_customer_detail_attributes_work_address_house_name",
                ).valid();
                $(
                  "#loan_customer_detail_attributes_work_address_house_number",
                ).valid();
                if (
                  ["es_pan", "es_pan_lsg", "es_slv"].includes(
                    document.documentElement.lang,
                  )
                ) {
                  $(
                    "#loan_customer_detail_attributes_work_jurisdiction_id",
                  ).valid();
                }
              }
            }

            // Mark funds origin fields as invalid if section is visible and incomplete
            const $fundsSection2 = $("#funds_origin_section");
            if ($fundsSection2.length && !$fundsSection2.hasClass("d-none")) {
              const $fundsSelect = $(".js-funds-origin-document-type");
              if (!$fundsSelect.val()) {
                $fundsSelect.addClass("is-invalid");
                $fundsSection2[0].scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              } else {
                $fundsSelect.removeClass("is-invalid");
                if ($fundsSelect.val() !== "family_support") {
                  const $emptyFiles = $fundsSection2
                    .find('.js-funds-file:not(.d-none) input[type="file"]')
                    .filter(function () {
                      return !operation.fileInputFilled(this);
                    });
                  if ($emptyFiles.length) {
                    $emptyFiles.addClass("is-invalid");
                    $emptyFiles.first()[0].scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }
                }
              }
            }

            $(".js-need-validation").find(":input.is-invalid:first").focus();
            return;
          }

          if (
            !$("#customSwitch_ley_81").prop("checked") ||
            ((gon.global["integration_type"]["equality"] ||
              gon.veriff_available) &&
              !$("#customSwitch0").prop("checked")) ||
            !$("#customSwitch1").prop("checked") ||
            !$("#customSwitch2").prop("checked") ||
            !$("#customSwitch3").prop("checked")
          ) {
            Swal.fire({
              icon: "error",
              html: i18n.t("bootbox.errors.failed_check_switch"),
            });

            return;
          }
        }

        if (isButtonNext || isButtonBack) {
          if (!element.dataset.step || !element.dataset.to_step) return;
          let currentStep = document.getElementById(
            "step-" + element.dataset.step,
          );
          let jumpStep = document.getElementById(
            "step-" + element.dataset.to_step,
          );
          if (!currentStep || !jumpStep) return;
          currentStep.classList.remove("active");
          jumpStep.classList.add("active");
          if (isButtonNext) {
            currentStep.classList.add("to-left");
          } else {
            jumpStep.classList.remove("to-left");
          }
          currentStep.classList.add("inactive");
          jumpStep.classList.remove("inactive");

          // Scroll the page (not the step): steps live in a horizontal flex
          // with overflow:hidden; scrolling the step itself blanks the wizard.
          requestAnimationFrame(function () {
            const header = document.querySelector(".card-header-loan");
            if (header) {
              header.scrollIntoView({ behavior: "smooth", block: "start" });
            } else {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          });
        }
      });
    }

    calculateAge() {
      const operation = this;
      var birthDate = $(operation.ui.customerBirthDate).val();
      var birthDateDay = new Date(birthDate + "T00:00:00");
      var today = new Date();

      if (
        $(operation.ui.devicePrice).val() != "" ||
        $(operation.ui.devicePrice).val() != 0
      ) {
        var validForm =
          !$(operation.ui.customerBirthDate).valid() ||
          !$(operation.ui.customerGender).valid();

        if (validForm) {
          $(operation.ui.customerBirthDate).valid();
          $(operation.ui.customerGender).valid();
          $(".js-need-validation").find(":input.is-invalid:first").focus();
          return;
        }
      }

      return parseInt(operation.currentAge(birthDate));
    }

    getPaymentPeriod() {
      const operation = this;
      const periods = $(operation.ui.jsRootWeb).data("payment-periods");
      const selectedId = Number($(operation.ui.paymentPeriodId).val());
      const matches = periods.filter((p) => p.id === selectedId);

      return matches[0] && matches[0].value;
    }

    getPaymentFrecuency() {
      const operation = this;
      var frecuency = $(operation.ui.paymentType).val();

      if (frecuency == "weekly") {
        return 4;
      } else if (frecuency == "monthly") {
        return 1;
      } else {
        return 2;
      }
    }

    getInitialPaymentDate() {
      const operation = this;

      var frecuency = $(operation.ui.paymentType).val();

      if (frecuency == "weekly") {
        return moment(new Date()).add(7, "days");
      } else if (frecuency == "monthly") {
        return moment(new Date()).add(1, "months");
      } else {
        return moment(new Date()).add(14, "days");
      }
    }

    getInterest() {
      const operation = this;
      var age = operation.calculateAge();
      var gender = $(operation.ui.customerGender).find("option:selected").val();
      var paymentPeriod = operation.getPaymentPeriod();
      var percentageCompostID = Number($(operation.ui.percentageCompost).val());

      if (
        typeof $(operation.ui.jsRootWeb).data("interest-rate")[
          paymentPeriod
        ] === "undefined" ||
        typeof $(operation.ui.jsRootWeb).data("interest-rate")[paymentPeriod][
          percentageCompostID
        ] === "undefined"
      ) {
        Swal.fire({
          icon: "error",
          html: i18n.t("bootbox.no_inital_payment_html"),
          confirmButtonText: "Aceptar",
        });

        return false;
      } else {
        var interest = $(operation.ui.jsRootWeb).data("interest-rate")[
          paymentPeriod
        ][percentageCompostID];
      }

      if (
        (gender == "female" && age >= gon.global.max_age.retired.female) ||
        (gender == "male" && age >= gon.global.max_age.retired.male)
      ) {
        return (interest - interest * 0.15) / 12 / 100;
      } else {
        return interest / 12 / 100;
      }
    }

    modalMessages(element, url, msg_type) {
      const operation = this;
      $(element).on("click", function () {
        var validForm = !$(operation.ui.customerCellphone).valid();

        if (validForm) {
          $(operation.ui.customerCellphone).valid();
          $(".js-need-validation").find(":input.is-invalid:first").focus();
          $(this).prop("checked", false);

          return;
        }

        if ($(this).prop("checked")) {
          var first_name = $(operation.ui.customerFirstName).val();
          var last_name = $(operation.ui.customerFirstLastName).val();

          $.ajax({
            method: "POST",
            url: url,
            dataType: "script",
            data: {
              loan_message: {
                msg_type: msg_type,
                dni: $(operation.ui.customerIdNumber).val(),
                cellphone: $(operation.ui.customerCellphone).val(),
                fullname: `${first_name} ${last_name}`,
                loan_type: "cellular",
              },
            },
          })
            .done(function () {
              console.log("Done!");
            })
            .fail(function () {
              console.log("Error");
            });
        }
      });
    }

    addValidatorDevicePrice() {
      const operation = this;

      $(operation.ui.deviceModelId).on("select2:select", function (e) {
        var selectedData = e.params.data;
        var max_price = parseFloat(selectedData.max_price);

        $(operation.ui.devicePrice).val("");
        $(operation.ui.devicePrice).blur();

        $(operation.ui.devicePrice).rules("add", {
          maxPrice: max_price,
        });
      });
    }

    addValidatorIdentity() {
      const operation = this;
      // El timeout está configurado en minutos en el panel administrativo, lo pasamos a ms
      const veriffTimeoutMs = (gon.global["veriff_timeout"] || 10) * 60 * 1000;

      // ─── Interceptamos el click ANTES de marcar el switch ───────────────────
      $(operation.ui.customerSwtich0).on("click", function (evt) {
        if (!$(this).is(":checked")) {
          // Si se está desmarcando, simplemente dejamos que suceda
          return;
        }

        var isVeriffAvailable = gon.veriff_available;

        // Sin Veriff: validar fotos manuales antes de continuar
        if (
          !isVeriffAvailable &&
          (!$(operation.ui.customerPhotoFront).valid() ||
            !$(operation.ui.customerPhotoBack).valid() ||
            !$(operation.ui.customerPhotoWithUser).valid() ||
            !$(operation.ui.customerSelfie).valid())
        ) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
          return;
        }

        // ── Con Veriff real: T&C → frame → polling ──────────────────────────
        if (isVeriffAvailable) {
          // Prevenir que el checkbox se marque hasta que el usuario acepte
          evt.preventDefault();

          // Mover el modal al <body> para evitar conflictos de z-index/eventos del form
          const $modal = $("#veriffTermsModal");
          if ($modal.parent()[0] !== document.body) {
            $modal.appendTo("body");
          }

          // Limpiar listeners previos para evitar duplicados
          $modal.off("hidden.bs.modal.veriffTerms");
          $("#veriffTermsAccept").off("click.veriffTerms");
          $("#veriffTermsReject").off("click.veriffTerms");

          $modal.modal("show");

          // Aceptar → marcar switch y lanzar Veriff
          $("#veriffTermsAccept").one("click.veriffTerms", function (e) {
            e.stopPropagation();
            $modal.modal("hide");
            $("#customSwitch0").prop("checked", true);
            operation._launchVeriff(isVeriffAvailable, veriffTimeoutMs);
          });

          // Cancelar → dejar switch sin marcar
          $("#veriffTermsReject").one("click.veriffTerms", function (e) {
            e.stopPropagation();
            $modal.modal("hide");
            $("#customSwitch0").prop("checked", false);
          });

          $modal.one("hidden.bs.modal.veriffTerms", function () {
            // Fallback: si se cerró sin aceptar, asegurar switch desmarcado
            if (!$("#customSwitch0").prop("checked")) {
              $("#customSwitch0").prop("checked", false);
            }
          });

          return; // Salimos; el flujo continúa en los listeners del modal
        }

        // Sin Veriff (development sin credenciales/webhook, o solo equality):
        // NO llamar a /providers/veriff/sessions — solo dejar el switch marcado.
        return;
      });
    }

    _launchVeriff(isVeriffAvailable, veriffTimeoutMs) {
      const operation = this;

      var requestData = {
        customer_consent_id: $("#customer_consent_id").val(),
        first_name: $(operation.ui.customerFirstName).val(),
        last_name:
          $(operation.ui.customerFirstLastName).val() +
          " " +
          $(operation.ui.customerSecondLastName).val(),
        id_number: $(operation.ui.customerIdNumber).val(),
      };

      if (!isVeriffAvailable) {
        requestData.photo_front = $(operation.ui.customerPhotoFrontTemp)
          .val()
          .split(",")[1];
        requestData.photo_back = $(operation.ui.customerPhotoBackTemp)
          .val()
          .split(",")[1];
        requestData.photo_selfie = $(operation.ui.customerSelfieTemp)
          .val()
          .split(",")[1];
      }

      operation._blockNextButton("Iniciando Verificación...");

      bootbox.dialog({
        centerVertical: true,
        closeButton: false,
        message: i18n.t("bootbox.processing_html"),
      });

      var ajaxTimeout = setTimeout(function () {
        operation.hideBootBox();
        operation._blockNextButton(
          i18n.t("veriff.timeout_error", {
            defaultValue: "El tiempo de espera de verificación se ha agotado.",
          }),
        );
      }, veriffTimeoutMs);

      $.ajax({
        method: "POST",
        url: "/providers/veriff/sessions",
        data: requestData,
        dataType: "json",
      })
        .done(function (data) {
          if (data.success) {
            if ($("#loan_veriff_session_id").length === 0) {
              $("<input>")
                .attr({
                  type: "hidden",
                  id: "loan_veriff_session_id",
                  name: "loan[veriff_session_id]",
                  value: data.session_id,
                })
                .appendTo("form");
            } else {
              $("#loan_veriff_session_id").val(data.session_id);
            }

            if (isVeriffAvailable && data.session_url) {
              operation.hideBootBox();
              createVeriffFrame({
                url: data.session_url,
                onEvent: function (msg) {
                  if (msg === "FINISHED") {
                    bootbox.dialog({
                      centerVertical: true,
                      closeButton: false,
                      message:
                        i18n.t("bootbox.processing_html") ||
                        "Procesando verificación...",
                    });
                    startPolling(data.session_id, ajaxTimeout);
                  } else if (msg === "CANCELED" || msg === "ABANDONED") {
                    // Usuario cerró Veriff sin completar → revertir switch y desbloquear botón
                    clearTimeout(ajaxTimeout);
                    $("#customSwitch0").prop("checked", false);
                    operation._unblockNextButton();
                  } else if (msg === "ERROR") {
                    clearTimeout(ajaxTimeout);
                    $("#customSwitch0").prop("checked", false);
                    operation._blockNextButton(
                      "Ocurrió un error en la verificación. Por favor, intente nuevamente.",
                    );
                  }
                },
              });
            } else if (data.skipped || data.status === "approved") {
              clearTimeout(ajaxTimeout);
              operation.hideBootBox();
              operation._unblockNextButton();
            } else {
              startPolling(data.session_id, ajaxTimeout);
            }

            function startPolling(sessionId, ajaxTimeout) {
              var pollInterval = setInterval(function () {
                $.ajax({
                  method: "GET",
                  url: "/providers/veriff/sessions/" + sessionId + "/status",
                  dataType: "json",
                })
                  .done(function (statusData) {
                    if (statusData.status === "approved") {
                      clearInterval(pollInterval);
                      clearTimeout(ajaxTimeout);
                      operation.hideBootBox();
                      operation._unblockNextButton();
                    } else if (
                      statusData.status === "resubmission_requested" ||
                      statusData.status === "resubmission"
                    ) {
                      clearInterval(pollInterval);
                      clearTimeout(ajaxTimeout);
                      operation.hideBootBox();
                      var resubmissionMsg =
                        statusData.reason ||
                        "Se requiere que envíe nuevamente las fotos.";
                      operation._blockNextButton(resubmissionMsg);
                    } else if (
                      statusData.status === "declined" ||
                      statusData.status === "abandoned"
                    ) {
                      clearInterval(pollInterval);
                      clearTimeout(ajaxTimeout);
                      operation.hideBootBox();
                      var declinedMsg =
                        statusData.reason ||
                        "La verificación falló. Por favor, intente nuevamente.";
                      operation._blockNextButton(declinedMsg);
                    }
                  })
                  .fail(function () {
                    clearInterval(pollInterval);
                    clearTimeout(ajaxTimeout);
                    operation.hideBootBox();
                    operation._blockNextButton(
                      "La verificación falló. Por favor, intente nuevamente.",
                    );
                  });
              }, 2000);

              var originalTimeout = ajaxTimeout;
              ajaxTimeout = setTimeout(function () {
                clearInterval(pollInterval);
                clearTimeout(originalTimeout);
                operation.hideBootBox();
                operation._blockNextButton(
                  "El tiempo de espera de verificación se ha agotado.",
                );
              }, veriffTimeoutMs);
            }
          } else {
            clearTimeout(ajaxTimeout);
            operation.hideBootBox();
            operation._blockNextButton(
              "La verificación falló. Por favor, intente nuevamente.",
            );
          }
        })
        .fail(function (jqXHR, textStatus) {
          clearTimeout(ajaxTimeout);
          operation.hideBootBox();
          var msg =
            textStatus === "timeout"
              ? "El tiempo de espera de verificación se ha agotado."
              : "La verificación falló. Por favor, intente nuevamente.";
          operation._blockNextButton(msg);
        });
    }

    addValidatorIdentityPhotos() {
      const operation = this;

      $(operation.ui.customerPhotoFront).on("click", function (evt) {
        if ($(this).data("locked") === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }
      });

      $(operation.ui.customerPhotoBack).on("click", function (evt) {
        if ($(this).data("locked") === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }
      });

      $(operation.ui.customerPhotoWithUser).on("click", function (evt) {
        if ($(this).data("locked") === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }
      });

      $(operation.ui.customerSelfie).on("click", function (evt) {
        if ($(this).data("locked") === true) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }
      });
    }

    // Bloquea el botón "Siguiente" del paso 3 mostrando un mensaje de error al vendedor
    _blockNextButton(message) {
      const btn = $('button.step_button--next[data-step="3"]');
      btn
        .prop("disabled", true)
        .addClass("btn-danger")
        .removeClass("btn-primary");

      // Mostrar o actualizar el mensaje de alerta
      let alert = $("#veriff-error-alert");
      if (alert.length === 0) {
        alert = $(
          '<div id="veriff-error-alert" class="alert alert-danger mt-3" role="alert"></div>',
        );
        btn.closest(".step_footer").prepend(alert);
      }
      alert.text(message).show();
    }

    // Rehabilita el botón "Siguiente" y quita el mensaje de error (verificación exitosa)
    _unblockNextButton() {
      const btn = $('button.step_button--next[data-step="3"]');
      btn
        .prop("disabled", false)
        .removeClass("btn-danger")
        .addClass("btn-primary");
      $("#veriff-error-alert").hide();
    }

    // Datacultr Validation
    bindDatacultrValidation() {
      const operation = this;

      if (this._handleDatacultrClick) {
        document.removeEventListener("click", this._handleDatacultrClick);
      }

      this._handleDatacultrClick = async (evt) => {
        const btn = evt.target.closest(".step_validate_datacultr");
        if (!btn) return;

        evt.stopPropagation();

        const loader = document.querySelector(operation.ui.loader);
        const loanId = btn.dataset.loanId;

        const url =
          btn.dataset.url ||
          (window.Routes &&
          typeof Routes.js_validate_datacultr_path === "function"
            ? Routes.js_validate_datacultr_path()
            : "/js_validate_datacultr");

        if (!loanId) {
          console.warn("[Datacultr] Missing data-loan-id on button");
          return;
        }

        const csrf =
          document
            .querySelector('meta[name="csrf-token"]')
            ?.getAttribute("content") || "";

        btn.disabled = true;
        if (loader) loader.classList.remove("d-none");

        try {
          const r = await fetch(url, {
            method: "POST",
            headers: {
              "X-CSRF-Token": csrf,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ loan_id: Number(loanId) }),
          });

          let data;
          try {
            data = await r.json();
          } catch {
            throw new Error("Respuesta no válida del servidor");
          }

          if (!r.ok) {
            throw new Error(data?.error || `HTTP ${r.status}`);
          }

          if (data.success === true && data.body === true) {
            Swal.fire({
              icon: "success",
              title: "Dispositivo se encuentra registrado en Datacultr",
              confirmButtonText: "OK",
              customClass: { confirmButton: "swal-ok-btn" },
            });
          } else if (data.success === true && data.body === false) {
            Swal.fire({
              icon: "warning",
              title: "Dispositivo no se encuentra registrado en Datacultr",
              confirmButtonText: "OK",
              customClass: { confirmButton: "swal-ok-btn" },
            });
          } else {
            throw new Error("Error al conectarse con Datacultr");
          }
        } catch (e) {
          Swal.fire({
            icon: "error",
            title: e.message || "Error al conectarse con Datacultr",
            confirmButtonText: "OK",
            customClass: { confirmButton: "swal-ok-btn" },
          });
        } finally {
          if (loader) loader.classList.add("d-none");
          btn.disabled = false;
        }
      };

      // Delegate clicks
      document.addEventListener("click", this._handleDatacultrClick);
    }

    loadSearchGeographicFilters() {
      const operation = this;

      const $province = $("#q_company_province_id_in");
      const $district = $("#q_company_district_id_in");
      const $jurisdiction = $("#q_company_jurisdiction_id_in");
      const $company = $("#q_company_id_in");

      // Si hay al menos una tienda seleccionada, se limpian y deshabilitan los filtros de
      // ubicación (provincia/distrito/corregimiento). Al deseleccionar la tienda se rehabilitan.
      var $locationFilters = $province.add($district).add($jurisdiction);

      $company.on("change", function () {
        var companyIds = $(this).val();
        var hasCompany = !!(companyIds && companyIds.length);

        if (hasCompany) {
          $province.val(null);
          $district.empty();
          if ($jurisdiction.length) {
            $jurisdiction.empty();
          }
          $locationFilters.prop("disabled", true).trigger("change.select2");
        } else {
          $locationFilters.prop("disabled", false).trigger("change.select2");
        }
      });

      // Cascada provincia -> distrito
      $province.on("change", function () {
        var provinceIds = $(this).val();

        $district.empty();
        if ($jurisdiction.length) {
          $jurisdiction.empty();
        }

        if (provinceIds && provinceIds.length > 0) {
          $.ajax({
            url: operation.getJsDistrictsPath(),
            data: { object_id: provinceIds[0] },
            success: function (data) {
              data.results.forEach(function (item) {
                $district.append(
                  '<option value="' + item.id + '">' + item.text + "</option>",
                );
              });
              $district.trigger("change");
            },
          });
        }
      });

      // Cascada distrito -> corregimiento
      $district.on("change", function () {
        var districtIds = $(this).val();

        if ($jurisdiction.length) {
          $jurisdiction.empty();

          if (districtIds && districtIds.length > 0) {
            $.ajax({
              url: operation.getJsJurisdictionsPath(),
              data: { object_id: districtIds[0] },
              success: function (data) {
                data.results.forEach(function (item) {
                  $jurisdiction.append(
                    '<option value="' +
                      item.id +
                      '">' +
                      item.text +
                      "</option>",
                  );
                });
                $jurisdiction.trigger("change");
              },
            });
          }
        }
      });
    }

    getJsDistrictsPath() {
      return window.Routes && typeof Routes.js_districts_path === "function"
        ? Routes.js_districts_path()
        : "/js_districts";
    }

    getJsJurisdictionsPath() {
      return window.Routes && typeof Routes.js_jurisdictions_path === "function"
        ? Routes.js_jurisdictions_path()
        : "/js_jurisdictions";
    }
  }

  window.Loan = Loan;
})();

window.createVeriffFrame = createVeriffFrame;
